import React from 'react';
import { Pattern } from '@ritabygglov/core';
import { FixtureIconProps } from '../Icons';

interface SvgIconProp {
  color?: string;
  isFill: boolean;
  activeColor?: string;
}

export const PointerSvg = ({ color = 'var(--text)' }: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2547 15.359L9.40135 8.54529L8.70066 10.0118L12.7206 10.2618C13.4249 10.3103 13.7608 9.51179 13.2623 8.99686L5.84731 1.24277C5.385 0.75767 4.67348 1.04126 4.65903 1.72413L4.50011 12.5641C4.48927 13.3179 5.29832 13.6276 5.77508 13.0716L8.34309 10.0901L6.8225 9.49689L9.55665 16.5084C9.73002 16.9673 10.1309 17.0942 10.5174 16.9337L11.8754 16.3889C12.2836 16.2284 12.4389 15.7956 12.2547 15.359Z"
      fill={color}
    />
  </svg>
);

export const RectSvg = ({ color }: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.26014 18H14.3981C16.5085 18 17.6583 16.8292 17.6583 14.6991V3.31974C17.6583 1.18494 16.5085 0.0187988 14.3981 0.0187988H3.26014C1.15444 0.0187988 0 1.18025 0 3.31974V14.6991C0 16.8339 1.15444 18 3.26014 18ZM3.51873 15.5737C2.77527 15.5737 2.38276 15.2022 2.38276 14.4029V3.61128C2.38276 2.8119 2.77527 2.44513 3.51873 2.44513H14.1396C14.8784 2.44513 15.2755 2.8119 15.2755 3.61128V14.4029C15.2755 15.2022 14.8784 15.5737 14.1396 15.5737H3.51873Z"
      fill={color}
    />
  </svg>
);

export const LineSvg = ({ color }: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.412118 15.5764C-0.137373 16.1313 -0.137373 17.027 0.412118 17.5875C0.967105 18.1371 1.86828 18.1425 2.41777 17.5875L17.5837 2.42156C18.1388 1.87207 18.1388 0.965407 17.5837 0.41042C17.0287 -0.133577 16.133 -0.144566 15.5781 0.41042L0.412118 15.5764Z"
      fill={color}
    />
  </svg>
);

export const Dimension = ({ color }: SvgIconProp) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7037 1.05243C11.6831 0.239878 10.6188 0.372828 9.79771 1.40414L1.33523 12.0333C0.512021 13.0673 0.629472 14.1237 1.65006 14.9362L4.7922 17.4379C5.81013 18.2483 6.8804 18.1244 7.70148 17.0931L16.1661 6.46126C16.985 5.43263 16.8638 4.36449 15.8459 3.55406L12.7037 1.05243ZM11.8964 2.46228L14.6555 4.65894C15.0064 4.93832 15.0484 5.28689 14.7797 5.62439L6.5667 15.9402C6.30438 16.2696 5.95102 16.3122 5.60011 16.0328L2.84103 13.8361C2.49011 13.5568 2.45452 13.2002 2.71897 12.868L10.9319 2.55228C11.1964 2.2201 11.5455 2.1829 11.8964 2.46228ZM2.83844 12.0528L2.40764 12.5939L5.01671 14.6711C5.16672 14.7905 5.38001 14.759 5.50157 14.6063C5.6274 14.4483 5.59484 14.2473 5.43948 14.1236L2.83844 12.0528ZM3.6126 11.0804L3.1818 11.6215L4.97119 13.0461C5.12655 13.1698 5.3393 13.1335 5.45872 12.9835C5.58669 12.8228 5.55468 12.6266 5.39663 12.5008L3.6126 11.0804ZM4.38677 10.108L3.95383 10.6518L5.74322 12.0764C5.89858 12.2001 6.11346 12.1611 6.23076 12.0138C6.35659 11.8557 6.32884 11.6542 6.17079 11.5284L4.38677 10.108ZM5.15666 9.14101L4.72586 9.68211L6.51525 11.1067C6.67061 11.2304 6.88335 11.1941 7.00492 11.0414C7.13075 10.8834 7.09874 10.6872 6.94069 10.5614L5.15666 9.14101ZM5.93295 8.16597L5.50216 8.70705L7.29155 10.1317C7.44691 10.2554 7.65966 10.219 7.77693 10.0717C7.9049 9.91101 7.87502 9.71216 7.71698 9.58633L5.93295 8.16597ZM6.70927 7.19088L6.27844 7.73202L8.88751 9.80925C9.03752 9.92868 9.2508 9.89717 9.37026 9.74713C9.49824 9.58639 9.46567 9.38541 9.31031 9.26171L6.70927 7.19088ZM7.48127 6.22123L7.05048 6.76231L8.83986 8.18694C8.99523 8.31064 9.20797 8.27431 9.32739 8.12432C9.45322 7.96627 9.42334 7.76742 9.26529 7.64159L7.48127 6.22123ZM8.25545 5.24883L7.82466 5.78992L9.61404 7.21455C9.76941 7.33824 9.98215 7.30191 10.1016 7.15192C10.2274 6.99387 10.1975 6.79502 10.0395 6.66919L8.25545 5.24883ZM9.02748 4.27912L8.59879 4.81758L10.3882 6.24221C10.5435 6.3659 10.7541 6.33226 10.8736 6.18221C11.0016 6.02147 10.9696 5.82532 10.8115 5.69949L9.02748 4.27912ZM9.80376 3.30409L9.37297 3.84518L11.1624 5.26981C11.3177 5.3935 11.5305 5.35717 11.6477 5.20987C11.7736 5.05182 11.7458 4.85028 11.5878 4.72446L9.80376 3.30409ZM10.5779 2.3317L10.1472 2.87278L12.7562 4.95001C12.9062 5.06944 13.1195 5.03793 13.2411 4.88526C13.3669 4.7272 13.3343 4.52622 13.179 4.40253L10.5779 2.3317Z"
      fill={color}
    />
  </svg>
);

export const RightAngleIcon = ({ color }: SvgIconProp) => (
  <svg
    width="12"
    height="20"
    viewBox="0 0 19.02 19.02"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.83008 0C4.39453 0 5.66015 1.27441 5.66016 2.83008C5.66016 4.14823 4.76068 5.25668 3.54199 5.57422V7.97363H11V15.1006H13.4424C13.7568 13.8773 14.8681 12.9736 16.1895 12.9736C17.7451 12.9736 19.0195 14.2393 19.0195 15.8037C19.0195 17.3682 17.7451 18.6338 16.1895 18.6338C14.8713 18.6338 13.7629 17.7343 13.4453 16.5156H5.64062C5.48233 17.9224 4.28718 19.0195 2.83887 19.0195C1.26562 19.0195 5.17232e-06 17.7539 0 16.1982C0 16.1329 0.00448596 16.0682 0.00878906 16.0039C0.00452389 15.9406 -2.81388e-09 15.8769 0 15.8125C9.78904e-07 14.4818 0.906305 13.3743 2.12695 13.0635V5.57617C0.903831 5.26168 0 4.15137 0 2.83008C2.58625e-06 1.27441 1.26562 1.03582e-06 2.83008 0ZM4 13.2305C4.73179 13.5634 5.29631 14.1947 5.53516 14.9736H10V8.97363H4V13.2305Z"
      fill={color}
    />
  </svg>
);

export const AngleIcon = ({ color }: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 15.5H16.5"
      stroke={color}
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <path
      d="M2 15.5L13 2.5"
      stroke={color}
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <path
      d="M9.5 15.5C9.5 13.4 8.6 11.4 7.1 10"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
);

export const DottedBorder = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    id="icon"
  >
    <path
      id="icon"
      d="M3.07512 2.03703C3.63381 2.03703 4.0939 1.58175 4.0939 1.01851C4.0939 0.459974 3.63381 0 3.07512 0C2.51643 0 2.05634 0.459974 2.05634 1.01851C2.05634 1.58175 2.51643 2.03703 3.07512 2.03703ZM6.03286 2.03703C6.59155 2.03703 7.05164 1.58175 7.05164 1.01851C7.05164 0.459974 6.59155 0 6.03286 0C5.47418 0 5.01408 0.459974 5.01408 1.01851C5.01408 1.58175 5.47418 2.03703 6.03286 2.03703ZM8.99062 2.03703C9.55869 2.03703 10.0094 1.58175 10.0094 1.01851C10.0094 0.459974 9.55869 0 8.99062 0C8.43192 0 7.97653 0.459974 7.97653 1.01851C7.97653 1.58175 8.43192 2.03703 8.99062 2.03703ZM11.9577 2.03703C12.5165 2.03703 12.9765 1.58175 12.9765 1.01851C12.9765 0.459974 12.5165 0 11.9577 0C11.3944 0 10.939 0.459974 10.939 1.01851C10.939 1.58175 11.3944 2.03703 11.9577 2.03703ZM14.9155 2.03703C15.4742 2.03703 15.9343 1.58175 15.9343 1.01851C15.9343 0.459974 15.4742 0 14.9155 0C14.3568 0 13.8967 0.459974 13.8967 1.01851C13.8967 1.58175 14.3568 2.03703 14.9155 2.03703ZM16.9859 4.09752C17.5446 4.09752 18 3.63755 18 3.079C18 2.52047 17.5446 2.06049 16.9859 2.06049C16.4226 2.06049 15.9671 2.52047 15.9671 3.079C15.9671 3.63755 16.4226 4.09752 16.9859 4.09752ZM16.9859 7.0545C17.5446 7.0545 18 6.59921 18 6.03598C18 5.47744 17.5446 5.02216 16.9859 5.02216C16.4226 5.02216 15.9671 5.47744 15.9671 6.03598C15.9671 6.59921 16.4226 7.0545 16.9859 7.0545ZM16.9859 10.0114C17.5446 10.0114 18 9.55619 18 8.99765C18 8.43441 17.5446 7.97913 16.9859 7.97913C16.4226 7.97913 15.9671 8.43441 15.9671 8.99765C15.9671 9.55619 16.4226 10.0114 16.9859 10.0114ZM16.9859 12.9731C17.5446 12.9731 18 12.5132 18 11.9546C18 11.3961 17.5446 10.9362 16.9859 10.9362C16.4226 10.9362 15.9671 11.3961 15.9671 11.9546C15.9671 12.5132 16.4226 12.9731 16.9859 12.9731ZM16.9859 15.9301C17.5446 15.9301 18 15.4748 18 14.9116C18 14.353 17.5446 13.8978 16.9859 13.8978C16.4226 13.8978 15.9671 14.353 15.9671 14.9116C15.9671 15.4748 16.4226 15.9301 16.9859 15.9301ZM14.9202 18C15.4836 18 15.9389 17.54 15.9389 16.9815C15.9389 16.423 15.4836 15.9629 14.9202 15.9629C14.3615 15.9629 13.9061 16.423 13.9061 16.9815C13.9061 17.54 14.3615 18 14.9202 18ZM11.9624 18C12.5212 18 12.9812 17.54 12.9812 16.9815C12.9812 16.423 12.5212 15.9629 11.9624 15.9629C11.3991 15.9629 10.9436 16.423 10.9436 16.9815C10.9436 17.54 11.3991 18 11.9624 18ZM9 18C9.56338 18 10.014 17.54 10.014 16.9815C10.014 16.423 9.56338 15.9629 9 15.9629C8.43662 15.9629 7.98122 16.423 7.98122 16.9815C7.98122 17.54 8.43662 18 9 18ZM6.03756 18C6.60094 18 7.05634 17.54 7.05634 16.9815C7.05634 16.423 6.60094 15.9629 6.03756 15.9629C5.47887 15.9629 5.02348 16.423 5.02348 16.9815C5.02348 17.54 5.47887 18 6.03756 18ZM3.07981 18C3.6385 18 4.0986 17.54 4.0986 16.9815C4.0986 16.423 3.6385 15.9629 3.07981 15.9629C2.52113 15.9629 2.06103 16.423 2.06103 16.9815C2.06103 17.54 2.52113 18 3.07981 18ZM1.01878 15.9348C1.57746 15.9348 2.03756 15.4795 2.03756 14.921C2.03756 14.3577 1.57746 13.9025 1.01878 13.9025C0.460094 13.9025 0 14.3577 0 14.921C0 15.4795 0.460094 15.9348 1.01878 15.9348ZM1.01878 12.9778C1.57746 12.9778 2.03756 12.5179 2.03756 11.9593C2.03756 11.4008 1.57746 10.9408 1.01878 10.9408C0.460094 10.9408 0 11.4008 0 11.9593C0 12.5179 0.460094 12.9778 1.01878 12.9778ZM1.01878 10.0208C1.57746 10.0208 2.03756 9.56088 2.03756 9.00234C2.03756 8.4438 1.57746 7.98382 1.01878 7.98382C0.460094 7.98382 0 8.4438 0 9.00234C0 9.56088 0.460094 10.0208 1.01878 10.0208ZM1.01878 7.05919C1.57746 7.05919 2.03756 6.60391 2.03756 6.04536C2.03756 5.48213 1.57746 5.02685 1.01878 5.02685C0.460094 5.02685 0 5.48213 0 6.04536C0 6.60391 0.460094 7.05919 1.01878 7.05919ZM1.01878 4.10222C1.57746 4.10222 2.03756 3.64224 2.03756 3.0837C2.03756 2.52516 1.57746 2.06519 1.01878 2.06519C0.460094 2.06519 0 2.52516 0 3.0837C0 3.64224 0.460094 4.10222 1.01878 4.10222Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const DashedBorder = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    id="icon"
  >
    <path
      id="icon"
      d="M0 5.06486H2.42887V3.59624C2.42887 2.79602 2.82897 2.42887 3.58681 2.42887H5.04602V0H3.32322C1.17677 0 0 1.16266 0 3.3044V5.06486ZM6.57583 2.42887H11.4242V0H6.57583V2.42887ZM15.5711 5.06486H18V3.3044C18 1.16737 16.8232 0 14.6768 0H12.954V2.42887H14.4132C15.1663 2.42887 15.5711 2.79602 15.5711 3.59624V5.06486ZM15.5711 11.4006H18V6.59467H15.5711V11.4006ZM12.954 18H14.6768C16.8232 18 18 16.8279 18 14.6956V12.9304H15.5711V14.3991C15.5711 15.1992 15.1663 15.5712 14.4132 15.5712H12.954V18ZM6.57583 18H11.4242V15.5712H6.57583V18ZM3.32322 18H5.04602V15.5712H3.58681C2.82897 15.5712 2.42887 15.1992 2.42887 14.3991V12.9304H0V14.6956C0 16.8327 1.17677 18 3.32322 18ZM0 11.4006H2.42887V6.59467H0V11.4006Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const DotdashedBorder = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    id="icon"
  >
    <path
      d="M0 5.06486H2.42887V3.59624C2.42887 2.79602 2.82897 2.42887 3.58681 2.42887H5.04602V0H3.32322C1.17677 0 0 1.16266 0 3.3044V5.06486ZM7.57583 1.21443C7.57583 1.88515 8.11955 2.42887 8.79026 2.42887H9.20973C9.88044 2.42887 10.4242 1.88515 10.4242 1.21443V1.21443C10.4242 0.543721 9.88044 0 9.20973 0H8.79026C8.11955 0 7.57583 0.543721 7.57583 1.21443V1.21443ZM15.5711 5.06486H18V3.3044C18 1.16737 16.8232 0 14.6768 0H12.954V2.42887H14.4132C15.1663 2.42887 15.5711 2.79602 15.5711 3.59624V5.06486ZM15.5711 9.18616C15.5711 9.85689 16.1148 10.4006 16.7855 10.4006V10.4006C17.4563 10.4006 18 9.85689 18 9.18616V8.80913C18 8.1384 17.4563 7.59467 16.7855 7.59467V7.59467C16.1148 7.59467 15.5711 8.1384 15.5711 8.80913V9.18616ZM12.954 18H14.6768C16.8232 18 18 16.8279 18 14.6956V12.9304H15.5711V14.3991C15.5711 15.1992 15.1663 15.5712 14.4132 15.5712H12.954V18ZM7.57583 16.7856C7.57583 17.4563 8.11954 18 8.79025 18H9.20974C9.88045 18 10.4242 17.4563 10.4242 16.7856V16.7856C10.4242 16.1149 9.88045 15.5712 9.20974 15.5712H8.79025C8.11954 15.5712 7.57583 16.1149 7.57583 16.7856V16.7856ZM3.32322 18H5.04602V15.5712H3.58681C2.82897 15.5712 2.42887 15.1992 2.42887 14.3991V12.9304H0V14.6956C0 16.8327 1.17677 18 3.32322 18ZM0 9.18619C0 9.85691 0.54372 10.4006 1.21443 10.4006V10.4006C1.88515 10.4006 2.42887 9.85691 2.42887 9.18619V8.8091C2.42887 8.13839 1.88515 7.59467 1.21443 7.59467V7.59467C0.54372 7.59467 0 8.13839 0 8.8091V9.18619Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const PatternIcon = ({
  pattern,
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: {
  pattern: Pattern;
  color?: string;
  isFill: boolean;
  activeColor?: string;
}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      border: `1px solid ${isFill ? activeColor : color}`,
      borderRadius: '4px',
      backgroundColor: '#fff',
    }}
  >
    <rect fill={`url(#${pattern})`} width="18" height="18" />
  </svg>
);

export const IconCircle = ({ color }: Omit<SvgIconProp, 'isFill'>) => {
  const needsStroke =
    color === '#fff' || color === '#FFFFFF' || color === 'white';

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="8"
        cy="8"
        r="7"
        fill={color}
        stroke={needsStroke ? '#D0D3D7' : 'none'}
        strokeWidth="1"
      />
    </svg>
  );
};

export const IconNoStroke = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="7" stroke="#D0D3D7" strokeWidth="1" fill="none" />
    <line
      x1="3"
      y1="13"
      x2="13"
      y2="3"
      stroke="#D0D3D7"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const IconNoFill = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.2"
      d="M14.6768 0C16.828 2.76015e-06 18 1.16766 18 3.30469V14.6953C18 16.8276 16.828 18 14.6768 18H3.32324C1.17679 18 0 16.8323 0 14.6953V3.30469C0 1.16295 1.17679 0 3.32324 0H14.6768ZM4.44141 15.5713H14.4131C15.1661 15.5713 15.5712 15.1993 15.5713 14.3994V4.44141L4.44141 15.5713ZM3.58691 2.42871C2.82907 2.42871 2.42871 2.79647 2.42871 3.59668V14.3994C2.42873 14.5182 2.43853 14.6274 2.45605 14.7275L14.7285 2.45508C14.6313 2.43829 14.5262 2.42871 14.4131 2.42871H3.58691Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const IconDiagonalHatch = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.32322 18H14.6768C16.8279 18 18 16.8279 18 14.6956V3.3044C18 1.16737 16.8279 0 14.6768 0H3.32322C1.17677 0 0 1.16266 0 3.3044V14.6956C0 16.8327 1.17677 18 3.32322 18ZM3.58681 15.5712C2.82897 15.5712 2.42887 15.1992 2.42887 14.3991V3.59624C2.42887 2.79602 2.82897 2.42887 3.58681 2.42887H14.4132C15.1663 2.42887 15.5711 2.79602 15.5711 3.59624V14.3991C15.5711 15.1992 15.1663 15.5712 14.4132 15.5712H3.58681Z"
      fill={isFill ? activeColor : color}
    />
    <mask
      id="mask0_2581_289"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="14"
      height="14"
    >
      <path
        d="M3.58678 15.5712C2.82894 15.5712 2.42883 15.1993 2.42883 14.3992V3.59632C2.42883 2.79611 2.82894 2.42896 3.58678 2.42896H14.4132C15.1662 2.42896 15.571 2.79611 15.571 3.59632V14.3992C15.571 15.1993 15.1662 15.5712 14.4132 15.5712H3.58678Z"
        fill={isFill ? activeColor : color}
      />
    </mask>
    <g mask="url(#mask0_2581_289)">
      <path
        d="M-8 18.7488L16.7487 -5.99996"
        stroke={isFill ? activeColor : color}
      />
      <path
        d="M-5.52515 21.2236L19.2236 -3.5251"
        stroke={isFill ? activeColor : color}
      />
      <path
        d="M-3.05029 23.6985L21.6984 -1.05025"
        stroke={isFill ? activeColor : color}
      />
      <path
        d="M-0.575439 26.1733L24.1733 1.4246"
        stroke={isFill ? activeColor : color}
      />
    </g>
  </svg>
);

export const IconBricks = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6768 0C16.828 2.83378e-06 18 1.16766 18 3.30469V14.6953C18 16.8276 16.828 18 14.6768 18H3.32324C1.17679 18 0 16.8323 0 14.6953V3.30469C0 1.16295 1.17679 0 3.32324 0H14.6768ZM2.42871 14.3994C2.42881 15.1993 2.82917 15.5713 3.58691 15.5713H8.5V12.5H2.42871V14.3994ZM9.5 15.5713H14.4131C15.1661 15.5713 15.5712 15.1993 15.5713 14.3994V12.5H9.5V15.5713ZM2.42871 11.5H4.5V6.5H2.42871V11.5ZM13.5 11.5H15.5713V6.5H13.5V11.5ZM5.5 11.5H12.5V6.5H5.5V11.5ZM3.58691 2.42871C2.82907 2.42871 2.42871 2.79647 2.42871 3.59668V5.5H15.5713V3.59668C15.5713 2.79647 15.1662 2.42871 14.4131 2.42871H3.58691Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const IconBricksAlternative = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6768 0C16.828 2.83378e-06 18 1.16766 18 3.30469V14.6953C18 16.8276 16.828 18 14.6768 18H3.32324C1.17679 18 0 16.8323 0 14.6953V3.30469C0 1.16295 1.17679 0 3.32324 0H14.6768ZM2.42871 14.3994C2.42881 15.1993 2.82917 15.5713 3.58691 15.5713H7.5V12.5H2.42871V14.3994ZM8.5 15.5713H13.5V12.5H8.5V15.5713ZM14.5 15.5674C15.1972 15.5393 15.5712 15.168 15.5713 14.3994V12.5H14.5V15.5674ZM2.42871 11.5H4.5V6.5H2.42871V11.5ZM11.5 11.5H15.5713V6.5H11.5V11.5ZM5.5 11.5H10.5V6.5H5.5V11.5ZM3.58691 2.42871C2.82907 2.42871 2.42871 2.79647 2.42871 3.59668V5.5H7.5V2.42871H3.58691ZM8.5 5.5H13.5V2.42871H8.5V5.5ZM14.5 5.5H15.5713V3.59668C15.5713 2.8278 15.1973 2.45936 14.5 2.43164V5.5Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const IconWoodPanelVertical = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6768 0C16.828 2.83378e-06 18 1.16766 18 3.30469V14.6953C18 16.8276 16.828 18 14.6768 18H3.32324C1.17679 18 0 16.8323 0 14.6953V3.30469C0 1.16295 1.17679 0 3.32324 0H14.6768ZM3.58691 2.42871C2.82907 2.42871 2.42871 2.79647 2.42871 3.59668V14.3994C2.42881 15.1993 2.82917 15.5713 3.58691 15.5713H4V2.42871H3.58691ZM5 15.5713H7V2.42871H5V15.5713ZM8 15.5713H10V2.42871H8V15.5713ZM14 15.5713H14.4131C15.1661 15.5713 15.5712 15.1993 15.5713 14.3994V3.59668C15.5713 2.79647 15.1662 2.42871 14.4131 2.42871H14V15.5713ZM11 15.5713H13V2.42871H11V15.5713Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const IconWoodPanelHorizontal = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6768 0C16.828 2.83378e-06 18 1.16766 18 3.30469V14.6953C18 16.8276 16.828 18 14.6768 18H3.32324C1.17679 18 0 16.8323 0 14.6953V3.30469C0 1.16295 1.17679 0 3.32324 0H14.6768ZM3.58691 2.42871C2.82907 2.42871 2.42871 2.79647 2.42871 3.59668V4H15.5713V3.59668C15.5713 2.79647 15.1662 2.42871 14.4131 2.42871H3.58691ZM2.42871 5V7H15.5713V5H2.42871ZM2.42871 8V10H15.5713V8H2.42871ZM2.42871 14V14.3994C2.42881 15.1993 2.82917 15.5713 3.58691 15.5713H14.4131C15.1661 15.5713 15.5712 15.1993 15.5713 14.3994V14H2.42871ZM2.42871 11V13H15.5713V11H2.42871Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const IconWoodPanel = IconWoodPanelVertical;

export const IconRoofTiles = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6768 0C16.828 2.83378e-06 18 1.16766 18 3.30469V14.6953C18 16.8276 16.828 18 14.6768 18H3.32324C1.17679 18 0 16.8323 0 14.6953V3.30469C0 1.16295 1.17679 0 3.32324 0H14.6768ZM7.00684 12.6172L6.71875 12.708H4.27246L3.98438 12.6172L2.5 11.5723V14.9092C2.64573 15.3586 3.01404 15.5713 3.58691 15.5713H7.88184L8.49121 15.1426V11.5723L7.00684 12.6172ZM14.0156 12.6172L13.7275 12.708H11.2812L10.9932 12.6172L9.50879 11.5723V15.1436L10.1172 15.5713H14.4131C14.9839 15.5713 15.354 15.3572 15.5 14.9053V11.5723L14.0156 12.6172ZM7.00684 7.81152L6.71875 7.90234H4.27246L3.98438 7.81152L2.5 6.7666V10.3379L4.42871 11.6943H6.5625L8.49121 10.3369V6.7666L7.00684 7.81152ZM14.0156 7.81152L13.7275 7.90234H11.2812L10.9932 7.81152L9.50879 6.7666V10.3379L11.4375 11.6943H13.5713L15.5 10.3369V6.7666L14.0156 7.81152ZM3.58691 2.42871C3.01438 2.42871 2.64591 2.63842 2.5 3.08594V5.5332L4.42871 6.88965H6.5625L8.49121 5.53223V2.42871H3.58691ZM9.50879 2.42871V5.5332L11.4375 6.88965H13.5713L15.5 5.53223V3.08984C15.3538 2.63975 14.9836 2.42871 14.4131 2.42871H9.50879Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

interface IconColorFillProps extends SvgIconProp {
  fillColor: string;
}

export const IconColorFill = ({
  fillColor,
  isFill,
  activeColor = '#fff',
}: IconColorFillProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.32322 18H14.6768C16.8279 18 18 16.8279 18 14.6956V3.3044C18 1.16737 16.8279 0 14.6768 0H3.32322C1.17677 0 0 1.16266 0 3.3044V14.6956C0 16.8327 1.17677 18 3.32322 18ZM3.58681 15.5712C2.82897 15.5712 2.42887 15.1992 2.42887 14.3991V3.59624C2.42887 2.79602 2.82897 2.42887 3.58681 2.42887H14.4132C15.1663 2.42887 15.5711 2.79602 15.5711 3.59624V14.3991C15.5711 15.1992 15.1663 15.5712 14.4132 15.5712H3.58681Z"
      fill={isFill ? activeColor : '#000'}
    />
    <rect
      x="2.42887"
      y="2.42887"
      width="13.1422"
      height="13.1422"
      fill={fillColor}
    />
  </svg>
);

export const IconCircularDots = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.32322 18H14.6768C16.8279 18 18 16.8279 18 14.6956V3.3044C18 1.16737 16.8279 0 14.6768 0H3.32322C1.17677 0 0 1.16266 0 3.3044V14.6956C0 16.8327 1.17677 18 3.32322 18ZM3.58681 15.5712C2.82897 15.5712 2.42887 15.1992 2.42887 14.3991V3.59624C2.42887 2.79602 2.82897 2.42887 3.58681 2.42887H14.4132C15.1663 2.42887 15.5711 2.79602 15.5711 3.59624V14.3991C15.5711 15.1992 15.1663 15.5712 14.4132 15.5712H3.58681Z"
      fill={isFill ? activeColor : color}
    />
    <mask
      id="mask_circular_dots"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="14"
      height="14"
    >
      <path
        d="M3.58678 15.5712C2.82894 15.5712 2.42883 15.1993 2.42883 14.3992V3.59632C2.42883 2.79611 2.82894 2.42896 3.58678 2.42896H14.4132C15.1662 2.42896 15.571 2.79611 15.571 3.59632V14.3992C15.571 15.1993 15.1662 15.5712 14.4132 15.5712H3.58678Z"
        fill={isFill ? activeColor : color}
      />
    </mask>
    <g mask="url(#mask_circular_dots)">
      <circle cx="5" cy="5" r="1.2" fill={isFill ? activeColor : color} />
      <circle cx="9" cy="5" r="1.2" fill={isFill ? activeColor : color} />
      <circle cx="13" cy="5" r="1.2" fill={isFill ? activeColor : color} />
      <circle cx="5" cy="9" r="1.2" fill={isFill ? activeColor : color} />
      <circle cx="9" cy="9" r="1.2" fill={isFill ? activeColor : color} />
      <circle cx="13" cy="9" r="1.2" fill={isFill ? activeColor : color} />
      <circle cx="5" cy="13" r="1.2" fill={isFill ? activeColor : color} />
      <circle cx="9" cy="13" r="1.2" fill={isFill ? activeColor : color} />
      <circle cx="13" cy="13" r="1.2" fill={isFill ? activeColor : color} />
    </g>
  </svg>
);

export const IconArrowDown = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="6"
    height="4"
    viewBox="0 0 6 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ position: 'absolute', right: '0', bottom: '2px' }}
  >
    <path
      d="M1 1L3 3L5 1"
      stroke={isFill ? activeColor : color}
      strokeLinecap="round"
    />
  </svg>
);

export const SolidBorder = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    id="icon"
  >
    <path
      id="icon"
      d="M3.32322 18H14.6768C16.8279 18 18 16.8279 18 14.6956V3.3044C18 1.16737 16.8279 0 14.6768 0H3.32322C1.17677 0 0 1.16266 0 3.3044V14.6956C0 16.8327 1.17677 18 3.32322 18ZM3.58681 15.5712C2.82897 15.5712 2.42887 15.1992 2.42887 14.3991V3.59624C2.42887 2.79602 2.82897 2.42887 3.58681 2.42887H14.4132C15.1663 2.42887 15.5711 2.79602 15.5711 3.59624V14.3991C15.5711 15.1992 15.1663 15.5712 14.4132 15.5712H3.58681Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const OutlinedBorder = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    id="icon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1091 18H3.8909C2.76715 18 1.76076 17.6923 1.03664 16.9727C0.311624 16.2522 0 15.2486 0 14.1261V3.87396C0 2.74978 0.311378 1.74569 1.03697 1.02541C1.7615 0.306187 2.76808 0 3.8909 0H14.1091C15.2345 0 16.2413 0.307516 16.9653 1.02767C17.69 1.74855 18 2.75237 18 3.87396V14.1261C18 15.246 17.6897 16.2494 16.9656 16.9704C16.2421 17.6909 15.2354 18 14.1091 18ZM3.99711 14.0046C4.02547 14.0095 4.06808 14.014 4.12813 14.014H13.8719C13.9321 14.014 13.9746 14.0094 14.0026 14.0044C14.0083 13.9742 14.014 13.9273 14.014 13.8592V4.13661C14.014 4.07112 14.0088 4.02536 14.0033 3.99552C13.9748 3.99056 13.9321 3.98598 13.8719 3.98598H4.12813C4.06809 3.98598 4.02522 3.99044 3.99641 3.99533C3.99103 4.02553 3.98598 4.07139 3.98598 4.13661V13.8592C3.98598 13.927 3.99144 13.9741 3.99711 14.0046ZM14.1091 17.1H3.8909C1.9591 17.1 0.9 16.0494 0.9 14.1261V3.87396C0.9 1.94639 1.9591 0.9 3.8909 0.9H14.1091C16.0452 0.9 17.1 1.95063 17.1 3.87396V14.1261C17.1 16.0452 16.0452 17.1 14.1091 17.1ZM3.08598 13.8592C3.08598 14.5793 3.44607 14.914 4.12813 14.914H13.8719C14.5496 14.914 14.914 14.5793 14.914 13.8592V4.13661C14.914 3.41642 14.5496 3.08598 13.8719 3.08598H4.12813C3.44607 3.08598 3.08598 3.41642 3.08598 4.13661V13.8592Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const RotationIcon = ({ color = 'var(--text)' }: SvgIconProp) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    id="icon"
  >
    <g clipPath="url(#clip0_16_546)">
      <path
        id="icon"
        d="M0 13.0357C0 13.5627 0.331794 14 0.72545 14H13.0637C13.4601 14 13.7919 13.5627 13.7919 13.0357C13.7919 12.5126 13.4601 12.0716 13.0637 12.0716H2.47721L10.2603 1.72664C10.5415 1.35291 10.5387 0.739987 10.2603 0.362518C9.9763 -0.00747737 9.51515 -0.0112147 9.23402 0.362518L0.21651 12.3594C0.089978 12.5313 0 12.7854 0 13.0357ZM7.20388 13.1218H8.65476C8.71379 10.1581 7.81401 7.37374 6.24784 5.38922L5.21872 6.7496C6.52903 8.3791 7.26573 10.6626 7.20388 13.1218Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_16_546">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const RulerIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    id="icon"
  >
    <path
      id="icon"
      d="M12.7036 1.05243C11.683 0.239878 10.6187 0.372828 9.7976 1.40414L1.33513 12.0333C0.511915 13.0673 0.629365 14.1237 1.64996 14.9362L4.7921 17.4379C5.81002 18.2483 6.88029 18.1244 7.70137 17.0931L16.166 6.46126C16.9849 5.43263 16.8637 4.36449 15.8458 3.55406L12.7036 1.05243ZM11.8963 2.46228L14.6554 4.65894C15.0063 4.93832 15.0483 5.28689 14.7795 5.62439L6.56659 15.9402C6.30427 16.2696 5.95091 16.3122 5.6 16.0328L2.84092 13.8361C2.49001 13.5568 2.45441 13.2002 2.71886 12.868L10.9318 2.55228C11.1963 2.2201 11.5454 2.1829 11.8963 2.46228ZM2.83833 12.0528L2.40753 12.5939L5.01661 14.6711C5.16662 14.7905 5.3799 14.759 5.50147 14.6063C5.6273 14.4483 5.59474 14.2473 5.43937 14.1236L2.83833 12.0528ZM3.6125 11.0804L3.18169 11.6215L4.97108 13.0461C5.12644 13.1698 5.33919 13.1335 5.45862 12.9835C5.58658 12.8228 5.55457 12.6266 5.39652 12.5008L3.6125 11.0804ZM4.38666 10.108L3.95373 10.6518L5.74311 12.0764C5.89848 12.2001 6.11335 12.1611 6.23065 12.0138C6.35648 11.8557 6.32873 11.6542 6.17068 11.5284L4.38666 10.108ZM5.15656 9.14101L4.72576 9.68211L6.51514 11.1067C6.67051 11.2304 6.88325 11.1941 7.00481 11.0414C7.13064 10.8834 7.09863 10.6872 6.94058 10.5614L5.15656 9.14101ZM5.93284 8.16597L5.50205 8.70705L7.29144 10.1317C7.4468 10.2554 7.65955 10.219 7.77682 10.0717C7.9048 9.91101 7.87492 9.71216 7.71687 9.58633L5.93284 8.16597ZM6.70916 7.19088L6.27833 7.73202L8.8874 9.80925C9.03741 9.92868 9.2507 9.89717 9.37015 9.74713C9.49813 9.58639 9.46556 9.38541 9.3102 9.26171L6.70916 7.19088ZM7.48116 6.22123L7.05037 6.76231L8.83976 8.18694C8.99512 8.31064 9.20787 8.27431 9.32728 8.12432C9.45311 7.96627 9.42323 7.76742 9.26518 7.64159L7.48116 6.22123ZM8.25534 5.24883L7.82455 5.78992L9.61393 7.21455C9.7693 7.33824 9.98205 7.30191 10.1015 7.15192C10.2273 6.99387 10.1974 6.79502 10.0394 6.66919L8.25534 5.24883ZM9.02738 4.27912L8.59868 4.81758L10.3881 6.24221C10.5434 6.3659 10.754 6.33226 10.8735 6.18221C11.0015 6.02147 10.9694 5.82532 10.8114 5.69949L9.02738 4.27912ZM9.80365 3.30409L9.37286 3.84518L11.1623 5.26981C11.3176 5.3935 11.5304 5.35717 11.6476 5.20987C11.7735 5.05182 11.7457 4.85028 11.5877 4.72446L9.80365 3.30409ZM10.5778 2.3317L10.147 2.87278L12.7561 4.95001C12.9061 5.06944 13.1194 5.03793 13.241 4.88526C13.3668 4.7272 13.3342 4.52622 13.1789 4.40253L10.5778 2.3317Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const DimensionNoneIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0055 1.87967C11.8266 0.848395 12.8912 0.714695 13.9118 1.52713L17.0534 4.02908C18.0713 4.83951 18.1926 5.90768 17.3737 6.93631L13.4625 11.8474L17.9577 16.3426C18.3482 16.7331 18.3482 17.3661 17.9577 17.7566C17.5671 18.1471 16.9341 18.1471 16.5436 17.7566L12.2096 13.4226L8.9098 17.5681C8.08872 18.5994 7.01757 18.7233 5.99965 17.9129L2.85805 15.4109C1.8376 14.5984 1.72043 13.5425 2.54359 12.5086L6.4225 7.63553L2.54359 3.75662C2.15319 3.36611 2.15316 2.73305 2.54359 2.34256C2.93408 1.95207 3.56712 1.95214 3.95766 2.34256L7.67641 6.06131L11.0055 1.87967ZM6.68813 9.87381L8.14906 11.0369C8.30669 11.1627 8.33824 11.3585 8.21254 11.5164C8.09099 11.669 7.87863 11.7054 7.72328 11.5818L6.25746 10.4148L5.91859 10.8406L7.37855 12.0037C7.53655 12.1295 7.5648 12.331 7.4391 12.489C7.32181 12.6364 7.10618 12.6752 6.95082 12.5515L5.485 11.3846L5.14418 11.8133L6.60414 12.9763C6.76219 13.1022 6.7946 13.298 6.66664 13.4588C6.54724 13.6087 6.33466 13.6448 6.17934 13.5213L4.71352 12.3543L4.36977 12.7859L6.64711 14.5984C6.80247 14.7221 6.83544 14.9238 6.70961 15.0818C6.58803 15.2344 6.37422 15.2657 6.22426 15.1463L3.9391 13.3269L3.92641 13.3435C3.66243 13.6755 3.69797 14.0321 4.04848 14.3113L6.80824 16.5076C7.15916 16.787 7.51272 16.7443 7.77504 16.4148L11.067 12.2801L9.05727 10.2703C9.07576 10.3619 9.05413 10.4597 8.985 10.5467C8.86781 10.6939 8.65498 10.7306 8.49965 10.6072L7.03383 9.44021L6.68813 9.87381ZM13.1041 2.93728C12.7534 2.65815 12.4047 2.69537 12.1403 3.02713L12.11 3.06424L14.3873 4.87771C14.5424 5.0014 14.5745 5.20221 14.4489 5.36014C14.3274 5.51267 14.1145 5.54459 13.9645 5.42557L11.6793 3.60525L11.3356 4.03689L12.7955 5.19998C12.9535 5.32581 12.9819 5.52732 12.8561 5.68533C12.7389 5.83254 12.5261 5.86833 12.3707 5.7449L10.9049 4.57791L10.5592 5.01248L12.0192 6.17459C12.1771 6.30034 12.2094 6.49632 12.0817 6.65701C11.9623 6.80697 11.7517 6.84101 11.5963 6.71756L10.1305 5.55057L9.78676 5.98123L11.2477 7.14432C11.4055 7.27014 11.4349 7.46876 11.3092 7.62674C11.1898 7.77673 10.9773 7.81293 10.8219 7.68924L9.35609 6.52225L9.01332 6.95389L10.4733 8.11697C10.6312 8.24281 10.6606 8.4414 10.5348 8.59939C10.4831 8.66419 10.4138 8.70583 10.3395 8.72439L12.32 10.7049L15.9879 6.09939C16.2564 5.76197 16.2138 5.41386 15.8629 5.13455L13.1041 2.93728ZM7.46449 8.89822L8.55043 9.76346L7.56215 8.77518L7.46449 8.89822Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const DimensionSmallIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0053 1.87967C11.8264 0.848395 12.891 0.714695 13.9116 1.52713L17.0532 4.02908C18.071 4.8395 18.1924 5.90773 17.3735 6.93631L16.7417 7.7283C16.9047 7.85591 17.0478 8.01339 17.1587 8.20193L17.227 8.33182L17.2768 8.4451C17.3833 8.71226 17.426 8.99749 17.4008 9.28787V9.29178C17.3704 9.62565 17.2452 9.93516 17.0376 10.198L17.0385 10.199C17.0378 10.1999 17.0363 10.2011 17.0356 10.2019C17.0292 10.21 17.0226 10.2193 17.0161 10.2273L17.0151 10.2263C16.8716 10.4055 16.7004 10.5447 16.5122 10.6443C16.6772 10.7531 16.8326 10.8749 16.9721 11.0144C17.5051 11.5476 17.7445 12.232 17.7446 12.9715C17.7445 13.4562 17.6456 13.9261 17.4292 14.3592C17.2184 14.7804 16.918 15.1372 16.5444 15.4246L16.5376 15.4295L16.5317 15.4344C16.1609 15.71 15.7346 15.9077 15.2739 16.0418C14.8003 16.1795 14.29 16.242 13.7544 16.242C13.4382 16.2419 13.1127 16.218 12.7798 16.1726V16.1717C12.4509 16.1325 12.1309 16.0711 11.8227 15.9842C11.5166 15.8978 11.2276 15.7911 10.9604 15.6619C10.8375 15.6027 10.7155 15.5301 10.601 15.4422L8.90964 17.5681C8.08863 18.5991 7.01724 18.7231 5.99948 17.9129L2.85788 15.4109C1.83755 14.5985 1.72057 13.5424 2.54342 12.5086L11.0053 1.87967ZM7.46432 8.89822L8.92428 10.0613C9.08214 10.1871 9.11257 10.386 8.98483 10.5467C8.86761 10.6935 8.65468 10.7304 8.49948 10.6072L7.03366 9.44021L6.68796 9.87381L8.14889 11.0369C8.30641 11.1627 8.33804 11.3585 8.21237 11.5164C8.09081 11.6687 7.87832 11.7052 7.72311 11.5818L6.25729 10.4148L5.91842 10.8406L7.37839 12.0037C7.53626 12.1295 7.56459 12.3311 7.43893 12.489C7.32161 12.636 7.10588 12.675 6.95065 12.5515L5.48483 11.3846L5.14401 11.8133L6.60397 12.9763C6.7619 13.1022 6.7944 13.2981 6.66647 13.4588C6.54705 13.6083 6.33435 13.6446 6.17917 13.5213L4.71335 12.3543L4.3696 12.7859L6.64694 14.5984C6.80219 14.7221 6.83523 14.9238 6.70944 15.0818C6.58784 15.234 6.37392 15.2654 6.22409 15.1463L3.93893 13.3269L3.92624 13.3435C3.66257 13.6754 3.69792 14.0322 4.04831 14.3113L6.80807 16.5076C7.15881 16.7868 7.51261 16.7439 7.77487 16.4148L9.97799 13.6472C10.0347 13.3981 10.1391 13.1602 10.2993 12.948C10.4721 12.7137 10.6955 12.5338 10.9536 12.4178C10.8924 12.3634 10.8323 12.3069 10.7758 12.2469C10.262 11.7001 10.0347 11.0109 10.0346 10.2713C10.0346 10.2597 10.0345 10.2477 10.0346 10.2361L7.81003 8.46463L7.46432 8.89822ZM14.0151 7.97146C13.5688 7.97151 13.1608 8.02816 12.7944 8.14139C12.5567 8.21187 12.3401 8.30447 12.143 8.4158C12.0564 8.46469 11.9738 8.51724 11.895 8.574C11.882 8.58339 11.8678 8.59175 11.8549 8.60135L11.6704 8.75955C11.6176 8.81004 11.5678 8.86372 11.521 8.91873C11.5192 8.92082 11.5169 8.92246 11.5151 8.92459C11.458 8.99218 11.4052 9.06314 11.3569 9.13748C11.356 9.13878 11.3558 9.14106 11.3549 9.14236C11.3156 9.20323 11.278 9.26648 11.2446 9.33182L11.1528 9.54764C11.1284 9.61655 11.1081 9.68802 11.0913 9.76053C11.0908 9.76251 11.0897 9.76438 11.0893 9.76639C11.0694 9.85361 11.0554 9.9435 11.0464 10.0359L11.0424 10.0799C11.0375 10.1423 11.0346 10.2065 11.0346 10.2713L11.0415 10.4646C11.0453 10.5131 11.0522 10.5605 11.059 10.6072C11.088 10.809 11.1436 10.9938 11.227 11.1619C11.2286 11.1651 11.2303 11.1685 11.2319 11.1717C11.2403 11.1883 11.2501 11.2043 11.2592 11.2205C11.3264 11.3431 11.4068 11.4575 11.5044 11.5613C11.8177 11.8946 12.295 12.1282 12.935 12.2615L14.1049 12.5115C14.2561 12.5437 14.3845 12.5796 14.4907 12.6179C14.6043 12.6591 14.6923 12.7035 14.7544 12.7517L14.8374 12.8269C14.8591 12.8517 14.8769 12.8782 14.8921 12.906C14.9267 12.9698 14.9448 13.0418 14.9448 13.1219L14.9399 13.1853C14.9201 13.3309 14.8314 13.4565 14.6743 13.5613C14.6527 13.5754 14.6287 13.588 14.603 13.6004C14.4221 13.6871 14.1391 13.7312 13.7544 13.7312C13.5447 13.7312 13.3233 13.713 13.0913 13.6756L12.8549 13.6316C12.7285 13.6053 12.6078 13.5727 12.4917 13.5379C12.314 13.4848 12.1479 13.4239 11.9946 13.3513C11.8014 13.2648 11.6283 13.2452 11.4751 13.2918C11.3217 13.3318 11.1983 13.4151 11.1049 13.5418C11.0116 13.6618 10.955 13.8017 10.935 13.9617C10.9151 14.1216 10.9418 14.2751 11.0151 14.4217C11.0624 14.5119 11.1334 14.5889 11.2251 14.657V14.658C11.2399 14.669 11.254 14.6818 11.27 14.6922C11.307 14.7163 11.3478 14.7385 11.3911 14.7596C11.3923 14.7601 11.3938 14.7609 11.395 14.7615C11.4775 14.8014 11.5647 14.8381 11.6557 14.8738C11.7356 14.9054 11.8183 14.9366 11.9048 14.9646C11.9652 14.9842 12.0276 15.0023 12.0913 15.0203C12.0923 15.0206 12.0932 15.021 12.0942 15.0213C12.3542 15.0946 12.6279 15.1481 12.9145 15.1814L13.3442 15.2263L13.7544 15.242C13.8193 15.242 13.8835 15.2378 13.9467 15.2351C14.1611 15.2279 14.3642 15.2083 14.5571 15.1765C14.6093 15.1688 14.6612 15.1624 14.7114 15.1521L14.9946 15.0818C15.0755 15.0583 15.1542 15.0315 15.2299 15.0037C15.2355 15.0017 15.2411 14.9989 15.2465 14.9969C15.2581 14.9926 15.2693 14.9876 15.2807 14.9832C15.2904 14.9793 15.3004 14.9763 15.31 14.9724C15.3438 14.959 15.377 14.944 15.4096 14.9295C15.6034 14.8448 15.7795 14.7473 15.935 14.6316C16.1948 14.4317 16.3947 14.1917 16.5346 13.9119C16.5696 13.8419 16.6002 13.7693 16.6264 13.6951C16.7051 13.4726 16.7445 13.2312 16.7446 12.9715C16.7446 12.9076 16.7417 12.8448 16.7368 12.784C16.7243 12.6311 16.6946 12.4883 16.6508 12.3543C16.5722 12.1128 16.445 11.9015 16.2651 11.7215C16.1053 11.5617 15.9038 11.4242 15.6626 11.3094C15.4691 11.2173 15.2493 11.1401 15.0034 11.0769C14.9421 11.0612 14.8795 11.045 14.8149 11.031L13.6548 10.781C13.3414 10.7144 13.1244 10.6351 13.0044 10.5418C12.891 10.4418 12.8344 10.3214 12.8344 10.1814C12.8344 10.1273 12.843 10.0762 12.8559 10.0271C12.8762 9.94907 12.9113 9.87671 12.9643 9.81131C12.9875 9.78483 13.0132 9.75924 13.0415 9.73611C13.0522 9.7273 13.0642 9.72004 13.0757 9.7117C13.0963 9.69674 13.1172 9.68118 13.1401 9.66775C13.2054 9.62925 13.2805 9.59699 13.3647 9.57107C13.538 9.51112 13.748 9.48123 13.9946 9.48123C14.2213 9.48123 14.4548 9.50488 14.6948 9.55154C14.8742 9.58065 15.0397 9.62176 15.1909 9.67557L15.1899 9.6785C15.2466 9.69874 15.3023 9.71838 15.3549 9.74197C15.3807 9.75275 15.407 9.75987 15.4321 9.76834C15.4913 9.78962 15.5472 9.80649 15.601 9.81717C15.606 9.81819 15.6108 9.82017 15.6157 9.82107H15.6167C15.6302 9.82351 15.6435 9.82517 15.6567 9.82693L15.6577 9.82791C15.6962 9.83302 15.7334 9.83644 15.769 9.83572C15.8093 9.83488 15.8487 9.83034 15.8852 9.82205C15.9614 9.80212 16.0296 9.7722 16.0893 9.73416C16.1492 9.69582 16.2014 9.64801 16.2446 9.59158C16.3378 9.47837 16.3913 9.34841 16.4048 9.20193C16.4061 9.18675 16.4052 9.17109 16.4057 9.15603C16.4106 9.01915 16.3846 8.8875 16.3247 8.7615C16.3092 8.72908 16.2902 8.69878 16.27 8.66971C16.2656 8.66336 16.2609 8.65734 16.2563 8.65115C16.2405 8.63011 16.2239 8.60988 16.2055 8.5906C16.1983 8.5829 16.1917 8.57459 16.184 8.56717L16.1821 8.56521L16.1186 8.5115C16.0808 8.48255 16.04 8.45512 15.9946 8.43143C15.7347 8.27814 15.4248 8.16491 15.0649 8.09158C14.8677 8.04693 14.6712 8.01561 14.476 7.99588H14.477C14.4099 7.98909 14.3428 7.98313 14.2758 7.97928C14.1888 7.97426 14.1017 7.97149 14.0151 7.97146ZM8.24069 7.92361L10.1411 9.43631C10.1916 9.24745 10.2611 9.06268 10.3501 8.88455L10.354 8.87576C10.3928 8.79992 10.4347 8.72577 10.479 8.65408C10.3564 8.75481 10.1809 8.76812 10.0473 8.66189L8.58249 7.4949L8.24069 7.92361ZM13.104 2.93728C12.7533 2.65815 12.4045 2.69537 12.1401 3.02713L12.1098 3.06424L14.3872 4.87771C14.5421 5.00141 14.5743 5.20225 14.4487 5.36014C14.3272 5.51231 14.1142 5.54437 13.9643 5.42557L11.6792 3.60525L11.3354 4.03689L12.7954 5.19998C12.9532 5.32582 12.9817 5.52736 12.8559 5.68533C12.7387 5.8322 12.5258 5.8681 12.3706 5.7449L10.9048 4.57791L10.559 5.01248L12.019 6.17459C12.1768 6.30035 12.2092 6.49637 12.0815 6.65701C11.9621 6.80662 11.7514 6.84078 11.5962 6.71756L10.1303 5.55057L9.78659 5.98123L11.2475 7.14432C11.4053 7.27014 11.4347 7.46881 11.309 7.62674C11.1896 7.77638 10.977 7.8127 10.8217 7.68924L9.35592 6.52225L9.01315 6.95389L10.4731 8.11697C10.5901 8.21028 10.636 8.34339 10.601 8.47049C10.7807 8.22113 10.9968 8.00007 11.2446 7.80935L11.2544 7.80154C11.6271 7.52204 12.0509 7.31856 12.5102 7.1824C12.9832 7.03761 13.4878 6.97153 14.0141 6.97146C14.4074 6.97148 14.8009 7.01509 15.1928 7.09744L15.9878 6.09939C16.2562 5.76202 16.2135 5.41384 15.8628 5.13455L13.104 2.93728Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const DimensionMediumIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0053 1.87967C11.8264 0.848395 12.891 0.714695 13.9116 1.52713L17.0532 4.02908C18.071 4.8395 18.1924 5.90773 17.3735 6.93631L17.2632 7.074C17.5172 7.14796 17.7657 7.277 17.9799 7.48904L17.9819 7.48807C17.9876 7.49353 17.9929 7.50014 17.9985 7.50564C18.0037 7.51089 18.01 7.51593 18.0151 7.52127L18.0132 7.52225C18.3927 7.90523 18.5112 8.39623 18.5112 8.83182V14.3816C18.5111 14.8218 18.3926 15.3069 18.0249 15.6922C17.6375 16.0977 17.129 16.2215 16.6811 16.2215C16.2287 16.2213 15.7374 16.0921 15.354 15.7088L15.3462 15.701L15.3383 15.6922C15.0752 15.4165 14.9401 15.0891 14.8842 14.7644C14.8393 14.8038 14.7915 14.8412 14.7417 14.8767L14.7426 14.8777C14.7387 14.8805 14.7339 14.8827 14.7299 14.8855C14.726 14.8884 14.7223 14.8925 14.7182 14.8953L14.7173 14.8933C14.3957 15.1192 14.0377 15.1814 13.7417 15.1814C13.4307 15.1814 13.0804 15.112 12.7651 14.8953C12.7121 14.8589 12.662 14.8198 12.6147 14.7791C12.5572 15.0989 12.4237 15.4207 12.1645 15.6922C11.7773 16.0975 11.2695 16.2214 10.8217 16.2215C10.5797 16.2214 10.3271 16.1827 10.0854 16.0896L8.90964 17.5681C8.08863 18.5991 7.01724 18.7231 5.99948 17.9129L2.85788 15.4109C1.83755 14.5985 1.72057 13.5424 2.54342 12.5086L11.0053 1.87967ZM6.68796 9.87381L8.14889 11.0369C8.30641 11.1627 8.33804 11.3585 8.21237 11.5164C8.09081 11.6687 7.87832 11.7052 7.72311 11.5818L6.25729 10.4148L5.91842 10.8406L7.37839 12.0037C7.53626 12.1295 7.56459 12.3311 7.43893 12.489C7.32161 12.636 7.10588 12.675 6.95065 12.5515L5.48483 11.3846L5.14401 11.8133L6.60397 12.9763C6.7619 13.1022 6.7944 13.2981 6.66647 13.4588C6.54705 13.6083 6.33435 13.6446 6.17917 13.5213L4.71335 12.3543L4.3696 12.7859L6.64694 14.5984C6.80219 14.7221 6.83523 14.9238 6.70944 15.0818C6.58784 15.234 6.37392 15.2654 6.22409 15.1463L3.93893 13.3269L3.92624 13.3435C3.66257 13.6754 3.69792 14.0322 4.04831 14.3113L6.80807 16.5076C7.15881 16.7868 7.51261 16.7439 7.77487 16.4148L9.03659 14.8289C9.00581 14.6785 8.9917 14.5274 8.99167 14.3816V10.5359C8.9893 10.5392 8.98738 10.5434 8.98483 10.5467C8.86761 10.6935 8.65468 10.7304 8.49948 10.6072L7.03366 9.44021L6.68796 9.87381ZM16.6821 7.991C16.4488 7.99101 16.2625 8.03833 16.1225 8.13162C15.9893 8.21824 15.8626 8.36458 15.7426 8.57107L14.9878 9.93143L14.9839 9.93728L13.7758 12.115L11.8022 8.57107C11.7173 8.41626 11.6247 8.29526 11.5249 8.20779C11.4916 8.17856 11.4573 8.15332 11.4223 8.13162C11.3927 8.11089 11.3593 8.09303 11.3247 8.07693C11.3129 8.07145 11.3009 8.06626 11.2885 8.06131C11.263 8.05109 11.2364 8.0419 11.2085 8.03396C11.1944 8.02996 11.1802 8.02567 11.1655 8.02225C11.1252 8.01287 11.0825 8.00483 11.0376 7.99978L10.8725 7.991C10.8123 7.991 10.7542 7.99606 10.6997 8.00271C10.6815 8.005 10.6635 8.00651 10.646 8.00955C10.6327 8.01179 10.6198 8.01469 10.6069 8.01736C10.5893 8.0211 10.5721 8.0255 10.5551 8.03006C10.5371 8.03482 10.5196 8.03999 10.5024 8.04568C10.3929 8.08235 10.2994 8.13777 10.2221 8.2117C10.0794 8.34212 10.0034 8.53013 9.99362 8.77615C9.99282 8.79424 9.99167 8.81309 9.99167 8.83182V9.31717H9.99264V10.201H9.99167V13.6297L9.99264 13.6277V14.3816C9.99271 14.6481 10.0627 14.8542 10.2026 15.0008C10.3126 15.1107 10.4558 15.1803 10.6333 15.2078L10.8217 15.2215C10.8848 15.2215 10.9444 15.2165 11.0005 15.2088C11.0448 15.2026 11.0866 15.1935 11.1264 15.1824C11.1368 15.1795 11.1467 15.1758 11.1567 15.1726C11.1957 15.1602 11.2326 15.1461 11.2671 15.1287C11.2728 15.1258 11.278 15.122 11.2837 15.1189C11.3156 15.1017 11.3456 15.083 11.3735 15.0613C11.3774 15.0583 11.3824 15.0566 11.3862 15.0535L11.4419 15.0017C11.4453 14.9982 11.4473 14.9927 11.4507 14.989C11.4713 14.9664 11.4908 14.9431 11.5083 14.9178C11.5127 14.9114 11.5168 14.9048 11.521 14.8982C11.58 14.8058 11.6203 14.697 11.6391 14.5701L11.6518 14.3816V11.3308L11.7231 11.4549V11.4539L12.5854 12.949V12.95L13.0415 13.742C13.128 13.8883 13.225 13.9988 13.3315 14.0721C13.3572 14.0897 13.3853 14.1037 13.4145 14.117C13.4168 14.118 13.4191 14.1189 13.4214 14.1199C13.4456 14.1306 13.4709 14.1394 13.4975 14.1472C13.5078 14.1503 13.5181 14.1534 13.5288 14.156C13.5588 14.1633 13.5898 14.1706 13.6225 14.1746L13.7426 14.1814C13.9153 14.1813 14.052 14.1451 14.1518 14.0721C14.2175 14.0269 14.2797 13.9664 14.3403 13.8933C14.3782 13.8478 14.4167 13.7974 14.4526 13.741L15.851 11.3074V14.3816L15.8647 14.5701C15.8661 14.5794 15.869 14.5883 15.8706 14.5974C15.8757 14.6267 15.8818 14.655 15.8891 14.6824C15.8911 14.6896 15.8929 14.6968 15.895 14.7039C15.9162 14.7756 15.9458 14.8401 15.9829 14.8982C15.9882 14.9066 15.9938 14.9146 15.9995 14.9226C16.015 14.9448 16.0313 14.9661 16.0493 14.9861C16.0537 14.991 16.0574 14.9969 16.062 15.0017C16.2085 15.148 16.415 15.2204 16.6811 15.2205L16.6821 15.2215C16.6847 15.2215 16.6873 15.2205 16.6899 15.2205C16.7498 15.2201 16.8064 15.2162 16.8598 15.2088C16.9045 15.2026 16.9467 15.1936 16.9868 15.1824C16.9961 15.1798 17.0051 15.1765 17.0141 15.1736C17.0553 15.1607 17.0942 15.1462 17.1303 15.1277C17.134 15.1259 17.1375 15.1238 17.1411 15.1219C17.179 15.1016 17.2143 15.0789 17.2465 15.0525L17.3012 15.0017L17.3022 15.0008C17.4071 14.8908 17.4732 14.7474 17.4995 14.5701L17.5122 14.3816V8.83084C17.5121 8.59183 17.4565 8.4034 17.3442 8.26639L17.2924 8.2117C17.2685 8.18666 17.2419 8.1641 17.2143 8.14334C17.2082 8.13872 17.2021 8.13407 17.1958 8.12967C17.139 8.09006 17.0749 8.05942 17.0034 8.03689C16.9982 8.03526 16.993 8.03356 16.9878 8.03201C16.8973 8.00548 16.7955 7.991 16.6821 7.991ZM7.46432 8.89822L8.92428 10.0613C8.9505 10.0822 8.97264 10.1062 8.99167 10.1306V9.40506L7.81003 8.46463L7.46432 8.89822ZM13.104 2.93728C12.7533 2.65815 12.4045 2.69537 12.1401 3.02713L12.1098 3.06424L14.3872 4.87771C14.5421 5.00141 14.5743 5.20225 14.4487 5.36014C14.3272 5.51231 14.1142 5.54437 13.9643 5.42557L11.6792 3.60525L11.3354 4.03689L12.7954 5.19998C12.9532 5.32582 12.9817 5.52736 12.8559 5.68533C12.7387 5.8322 12.5258 5.8681 12.3706 5.7449L10.9048 4.57791L10.559 5.01248L12.019 6.17459C12.1768 6.30035 12.2092 6.49637 12.0815 6.65701C11.9621 6.80662 11.7514 6.84078 11.5962 6.71756L10.1303 5.55057L9.78659 5.98123L11.0688 7.00174C11.3555 7.02431 11.6646 7.09903 11.9467 7.28201L11.9477 7.28103C11.9583 7.28762 11.9686 7.29575 11.979 7.30252C11.984 7.30591 11.9896 7.30883 11.9946 7.31228C12.3037 7.51768 12.5195 7.80413 12.6743 8.08475L13.3872 9.36404L15.9878 6.09939C16.2562 5.76202 16.2135 5.41384 15.8628 5.13455L13.104 2.93728ZM8.24069 7.92361L9.01217 8.53787C9.03746 8.34695 9.08923 8.15339 9.17819 7.96951L8.58249 7.4949L8.24069 7.92361ZM9.01315 6.95389L9.60397 7.42459C9.76215 7.28963 9.93457 7.19245 10.1128 7.12478L9.35592 6.52225L9.01315 6.95389Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const DimensionLargeIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0053 1.87967C11.8264 0.848395 12.891 0.714695 13.9116 1.52713L17.0532 4.02908C18.071 4.8395 18.1924 5.90773 17.3735 6.93631L13.8061 11.4168V12.6013H15.2456C15.6567 12.6013 16.1221 12.7112 16.4946 13.0613L16.4965 13.0603C16.5019 13.0652 16.5069 13.071 16.5122 13.076C16.5187 13.0822 16.5262 13.0881 16.5327 13.0945L16.5307 13.0955C16.9113 13.4614 17.0356 13.9376 17.0356 14.3621C17.0354 14.7956 16.9071 15.2692 16.5317 15.6375L16.5327 15.6385C16.5304 15.6405 16.527 15.6422 16.5249 15.6443C16.5215 15.6477 16.5186 15.6527 16.5151 15.656L16.5132 15.6541C16.1377 16.0182 15.6636 16.1316 15.2456 16.1316H11.896C11.4173 16.1316 10.9125 15.9963 10.5132 15.6131L10.4868 15.5867L8.90964 17.5681C8.08863 18.5991 7.01724 18.7231 5.99948 17.9129L2.85788 15.4109C1.83755 14.5985 1.72057 13.5424 2.54342 12.5086L11.0053 1.87967ZM7.46432 8.89822L8.92428 10.0613C9.08214 10.1871 9.11257 10.386 8.98483 10.5467C8.86761 10.6935 8.65468 10.7304 8.49948 10.6072L7.03366 9.44021L6.68796 9.87381L8.14889 11.0369C8.30641 11.1627 8.33804 11.3585 8.21237 11.5164C8.09081 11.6687 7.87832 11.7052 7.72311 11.5818L6.25729 10.4148L5.91842 10.8406L7.37839 12.0037C7.53626 12.1295 7.56459 12.3311 7.43893 12.489C7.32161 12.636 7.10588 12.675 6.95065 12.5515L5.48483 11.3846L5.14401 11.8133L6.60397 12.9763C6.7619 13.1022 6.7944 13.2981 6.66647 13.4588C6.54705 13.6083 6.33435 13.6446 6.17917 13.5213L4.71335 12.3543L4.3696 12.7859L6.64694 14.5984C6.80219 14.7221 6.83523 14.9238 6.70944 15.0818C6.58784 15.234 6.37392 15.2654 6.22409 15.1463L3.93893 13.3269L3.92624 13.3435C3.66257 13.6754 3.69792 14.0322 4.04831 14.3113L6.80807 16.5076C7.15881 16.7868 7.51261 16.7439 7.77487 16.4148L9.9653 13.6629V10.1804L7.81003 8.46463L7.46432 8.89822ZM11.7827 8.074C11.5388 8.09084 11.3462 8.17066 11.2055 8.31131C11.0458 8.47127 10.9653 8.70199 10.9653 9.00174V12.407L10.9663 12.4051V14.201C10.9663 14.437 11.0189 14.6319 11.1225 14.7859C11.1237 14.7877 11.1252 14.79 11.1264 14.7918C11.1469 14.8217 11.1693 14.85 11.1938 14.8767C11.1979 14.8813 11.2013 14.8869 11.2055 14.8914C11.2085 14.8943 11.2123 14.8964 11.2153 14.8992C11.2451 14.927 11.2772 14.9516 11.311 14.9744C11.318 14.9791 11.3253 14.9835 11.3325 14.9881C11.3686 15.0108 11.4063 15.0314 11.4467 15.0486C11.4563 15.0527 11.4663 15.0556 11.476 15.0594C11.5188 15.0758 11.5635 15.0897 11.6108 15.1004C11.6157 15.1015 11.6206 15.1023 11.6255 15.1033C11.676 15.114 11.7289 15.1225 11.7846 15.1267C11.786 15.1268 11.7872 15.1276 11.7885 15.1277C11.8233 15.1302 11.8592 15.1316 11.896 15.1316H15.2465C15.3732 15.1315 15.4849 15.1143 15.5815 15.0808C15.6299 15.0641 15.6745 15.0434 15.7153 15.0183C15.7559 14.9934 15.7935 14.9646 15.8266 14.9314C15.9315 14.8315 15.9966 14.6995 16.0229 14.5359L16.0366 14.3611C16.0366 14.2377 16.0189 14.1293 15.9839 14.0359C15.9665 13.9896 15.9444 13.947 15.9184 13.908C15.8922 13.8688 15.8616 13.8333 15.8266 13.8015C15.8102 13.7851 15.7922 13.7691 15.7739 13.7547C15.7088 13.7034 15.6316 13.667 15.5434 13.6414C15.5056 13.6304 15.4663 13.6194 15.4243 13.6131C15.3722 13.6053 15.3168 13.6018 15.2583 13.6013H12.8061V9.00174C12.8061 8.7019 12.7258 8.47128 12.5659 8.31131C12.5484 8.29303 12.5297 8.27574 12.5102 8.25955C12.4781 8.23279 12.4431 8.2093 12.4057 8.18826C12.3964 8.18299 12.3871 8.17755 12.3774 8.17264C12.3685 8.16812 12.3593 8.16416 12.3501 8.15994C12.3342 8.15265 12.3179 8.14582 12.3012 8.13943C12.2668 8.12629 12.2308 8.11455 12.1928 8.10525L12.1694 8.09939C12.1614 8.09763 12.1531 8.09709 12.145 8.09549C12.0658 8.07998 11.9796 8.07107 11.8862 8.07107C11.8507 8.07108 11.8162 8.07166 11.7827 8.074ZM8.24069 7.92361L9.9653 9.29666V9.00174C9.96531 8.87668 9.97397 8.74805 9.9946 8.6199L8.58249 7.4949L8.24069 7.92361ZM13.104 2.93728C12.7533 2.65815 12.4045 2.69537 12.1401 3.02713L12.1098 3.06424L14.3872 4.87771C14.5421 5.00141 14.5743 5.20225 14.4487 5.36014C14.3272 5.51231 14.1142 5.54437 13.9643 5.42557L11.6792 3.60525L11.3354 4.03689L12.7954 5.19998C12.9532 5.32582 12.9817 5.52736 12.8559 5.68533C12.7387 5.8322 12.5258 5.8681 12.3706 5.7449L10.9048 4.57791L10.559 5.01248L12.019 6.17459C12.1768 6.30035 12.2092 6.49637 12.0815 6.65701C11.9621 6.80662 11.7514 6.84078 11.5962 6.71756L10.1303 5.55057L9.78659 5.98123L11.2475 7.14432C11.2529 7.14864 11.2571 7.1545 11.2622 7.15896C11.4686 7.09884 11.68 7.07211 11.8852 7.07205C12.352 7.07205 12.8716 7.19911 13.271 7.60525L13.2729 7.60428C13.2764 7.60779 13.2793 7.61247 13.2827 7.616C13.2841 7.61734 13.2862 7.61855 13.2876 7.6199H13.2866C13.6346 7.97621 13.7737 8.4208 13.8003 8.84549L15.9878 6.09939C16.2562 5.76202 16.2135 5.41384 15.8628 5.13455L13.104 2.93728ZM9.01315 6.95389L10.2417 7.9324C10.3112 7.81741 10.396 7.70679 10.4985 7.60428C10.531 7.57177 10.5661 7.5425 10.6001 7.51346L9.35592 6.52225L9.01315 6.95389Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const DimensionXLargeIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.00551 1.87952C9.82652 0.848578 10.8913 0.714645 11.9118 1.52698L15.0534 4.02894C16.0711 4.83926 16.1923 5.90767 15.3737 6.93616L15.0075 7.39515C15.0958 7.45537 15.1822 7.52365 15.2623 7.60511L15.2643 7.60413C15.2678 7.60766 15.2706 7.61229 15.2741 7.61585C15.2754 7.61726 15.2776 7.61836 15.2789 7.61976H15.278C15.669 8.02003 15.7974 8.53173 15.7975 9.00159V12.6012H17.237C17.648 12.6013 18.1136 12.7112 18.486 13.0612L18.4879 13.0602C18.4933 13.0651 18.4982 13.0709 18.5036 13.0758C18.5101 13.0821 18.5176 13.0879 18.5241 13.0944L18.5221 13.0953C18.9026 13.4612 19.0269 13.9375 19.027 14.3619C19.0269 14.7955 18.8984 15.269 18.5231 15.6373L18.5241 15.6383C18.5219 15.6405 18.5185 15.6421 18.5163 15.6442C18.5128 15.6475 18.5099 15.6525 18.5065 15.6559L18.5045 15.6539C18.1291 16.0182 17.655 16.1314 17.237 16.1315H13.8873C13.4086 16.1315 12.9039 15.9963 12.5045 15.6129L12.4743 15.5826C12.4074 15.6612 12.3331 15.735 12.2516 15.8024C11.8842 16.1058 11.4473 16.2212 11.025 16.2213C10.6773 16.2213 10.3313 16.1388 10.0163 15.9528L10.0016 15.944L9.98793 15.9352C9.6936 15.7478 9.45571 15.4845 9.26234 15.2155V15.2145L9.03383 14.8991L6.9098 17.568C6.08875 18.5993 5.01755 18.7231 3.99965 17.9127L0.858047 15.4108C-0.162395 14.5982 -0.279574 13.5424 0.543594 12.5084L9.00551 1.87952ZM3.91859 10.8405L5.37855 12.0035C5.53636 12.1292 5.56445 12.331 5.4391 12.4889C5.32183 12.6362 5.10618 12.675 4.95082 12.5514L3.485 11.3844L3.14418 11.8131L4.60414 12.9762C4.762 13.1019 4.79425 13.298 4.66664 13.4586C4.54726 13.6085 4.33465 13.6446 4.17934 13.5211L2.71352 12.3541L2.36977 12.7858L4.64711 14.5983C4.80228 14.7219 4.83508 14.9237 4.70961 15.0817C4.58805 15.2342 4.37421 15.2654 4.22426 15.1461L1.9391 13.3268L1.92641 13.3434C1.66243 13.6753 1.69797 14.0319 2.04848 14.3112L4.80824 16.5075C5.15913 16.7868 5.51274 16.7441 5.77504 16.4147L6.00355 16.1266C5.79417 16.0594 5.59198 15.9545 5.40785 15.8024C5.06545 15.5195 4.84545 15.1349 4.78383 14.6881L4.78188 14.6715L4.77992 14.6539C4.72684 14.1384 4.92036 13.6935 5.18129 13.3532L6.52699 11.5748L6.28383 11.2526C6.29992 11.3405 6.27821 11.4336 6.21254 11.5162C6.09101 11.6689 5.87862 11.7052 5.72328 11.5817L4.25746 10.4147L3.91859 10.8405ZM10.9743 7.99183C10.7813 7.99191 10.6109 8.03839 10.4645 8.13148C10.3179 8.21815 10.1707 8.36943 10.0241 8.58265L8.82484 10.235L8.6559 9.99964L8.65492 10.0006L8.39613 9.64027L7.63441 8.58167C7.5245 8.42681 7.4142 8.30388 7.30434 8.21253C7.26773 8.18219 7.23153 8.15476 7.19496 8.13148C7.16107 8.10992 7.12498 8.09234 7.08852 8.07581C7.07922 8.07156 7.06966 8.06802 7.0602 8.06409C7.03334 8.05305 7.00633 8.04225 6.97816 8.03382C6.96528 8.02991 6.95226 8.02644 6.9391 8.02308C6.90201 8.01374 6.86404 8.00565 6.82484 8.00062L6.68422 7.99183C6.4511 7.99191 6.25737 8.05568 6.10414 8.18226C6.02772 8.24549 5.96728 8.31716 5.9225 8.3971L5.87074 8.51234V8.51331C5.86906 8.51817 5.86744 8.52305 5.86586 8.52796C5.85195 8.57072 5.84107 8.61514 5.83461 8.66175L5.8307 8.73402C5.83076 8.74142 5.83234 8.74905 5.83266 8.75648C5.83376 8.78373 5.83699 8.81099 5.84145 8.83851C5.84338 8.85018 5.84476 8.86195 5.8473 8.87366C5.85407 8.90545 5.86343 8.93724 5.87465 8.96937C5.88821 9.00769 5.90554 9.04579 5.92543 9.0846C5.93014 9.09386 5.93403 9.10363 5.9391 9.11292C5.96608 9.162 5.99685 9.21249 6.03383 9.26234L7.77895 11.5758L5.97426 13.9616C5.94262 14.0028 5.91644 14.0455 5.89223 14.0866C5.84315 14.1695 5.80759 14.2509 5.78871 14.3326C5.78312 14.3571 5.77891 14.3815 5.77602 14.4059C5.77011 14.4548 5.76905 14.5039 5.77406 14.5524C5.80082 14.7454 5.89149 14.9054 6.04457 15.0319C6.08052 15.0615 6.11941 15.0863 6.1598 15.109C6.16628 15.1127 6.17275 15.1163 6.17934 15.1198C6.21424 15.1381 6.25064 15.1533 6.28871 15.1666C6.29811 15.1699 6.30744 15.1734 6.31703 15.1764C6.36159 15.1902 6.408 15.2023 6.45668 15.2096H6.4684C6.5184 15.2165 6.57032 15.2223 6.62465 15.2223C6.81754 15.2222 6.98799 15.1788 7.13441 15.0924C7.28092 14.9992 7.43145 14.8454 7.58461 14.6325L8.82484 12.9049L10.0739 14.6325C10.1122 14.6858 10.1511 14.735 10.1891 14.7809C10.2648 14.8723 10.3397 14.9488 10.4137 15.0104C10.4509 15.0413 10.4874 15.0691 10.5241 15.0924C10.5563 15.1115 10.5904 15.1273 10.6246 15.1422C10.6377 15.1479 10.6514 15.1518 10.6647 15.1569C10.6881 15.1658 10.7117 15.1742 10.736 15.1813C10.7473 15.1846 10.7586 15.1882 10.7702 15.191C10.8085 15.2006 10.8479 15.2085 10.8883 15.2135C10.9323 15.2189 10.9776 15.2223 11.0241 15.2223C11.0764 15.2223 11.1271 15.2166 11.1754 15.2106C11.1914 15.2086 11.2068 15.2054 11.2223 15.2028C11.2571 15.1969 11.2904 15.1895 11.3229 15.1803C11.3377 15.1761 11.3525 15.1725 11.3668 15.1676C11.4104 15.1527 11.4527 15.1361 11.4918 15.1149L11.6149 15.0319C11.7023 14.9596 11.7653 14.875 11.8092 14.7809C11.8425 14.7104 11.866 14.6352 11.8746 14.5524C11.901 14.3613 11.8354 14.167 11.6793 13.9694C11.6775 13.967 11.6764 13.9639 11.6745 13.9616L10.7506 12.7418L9.86879 11.5778L11.6246 9.26234C11.771 9.0671 11.8378 8.87937 11.8278 8.70081C11.8269 8.68425 11.8271 8.66741 11.8248 8.65101C11.8202 8.60628 11.8103 8.56388 11.7985 8.52308C11.7955 8.51272 11.7912 8.50291 11.7877 8.4928C11.7783 8.46541 11.7673 8.43923 11.7545 8.4137C11.7481 8.40089 11.7422 8.38796 11.735 8.37562C11.715 8.34159 11.6931 8.30842 11.6666 8.27796L11.5651 8.18128C11.5302 8.15251 11.4922 8.12828 11.4528 8.10609C11.4401 8.09892 11.4268 8.09305 11.4137 8.08655C11.3875 8.07366 11.3607 8.0616 11.3327 8.0514C11.316 8.04528 11.2992 8.03898 11.2819 8.03382C11.2386 8.02105 11.1934 8.01041 11.1461 8.00355L10.9743 7.99183ZM13.8766 8.07288C13.5837 8.07297 13.3568 8.15241 13.1969 8.31214C13.0372 8.47212 12.9567 8.70286 12.9567 9.00257V14.2028C12.9567 14.2946 12.9653 14.3802 12.9811 14.4596C12.9832 14.4701 12.9856 14.4805 12.9879 14.4909C12.9979 14.5342 13.0111 14.5754 13.026 14.6149C13.0307 14.6274 13.0354 14.6398 13.0407 14.652C13.057 14.69 13.0752 14.7262 13.0963 14.7604C13.1021 14.7698 13.1087 14.7786 13.1149 14.7877C13.1398 14.8245 13.1661 14.8601 13.1969 14.8922C13.2292 14.9232 13.2654 14.9492 13.3024 14.9743C13.3096 14.9791 13.3165 14.9843 13.3239 14.9889C13.3607 15.012 13.3997 15.032 13.4411 15.0494C13.4479 15.0523 13.4546 15.0555 13.4616 15.0582C13.5057 15.0756 13.5521 15.0901 13.6012 15.1012C13.6061 15.1023 13.611 15.1031 13.6159 15.1041C13.6679 15.1152 13.7224 15.1244 13.7799 15.1285L13.8864 15.1325H17.237C17.4898 15.1324 17.6838 15.0652 17.817 14.9323C17.8937 14.8592 17.9484 14.768 17.983 14.6608C17.9857 14.6527 17.9885 14.6446 17.9909 14.6364C18.0144 14.5542 18.027 14.463 18.027 14.3619C18.0269 14.1307 17.9646 13.9525 17.8414 13.8268C17.8333 13.8184 17.8258 13.8093 17.817 13.8014C17.7871 13.7715 17.7535 13.7455 17.7174 13.7223C17.7025 13.7127 17.6874 13.7034 17.6715 13.695C17.6489 13.6829 17.625 13.6724 17.6002 13.6627C17.544 13.6408 17.4827 13.6239 17.4157 13.6139C17.3598 13.6055 17.3002 13.6012 17.237 13.6012H14.7975V9.00159C14.7975 8.99208 14.7957 8.98265 14.7955 8.97327C14.7947 8.92517 14.7919 8.87901 14.7868 8.8346C14.7856 8.8244 14.7843 8.81433 14.7829 8.80433C14.7756 8.75254 14.7658 8.70342 14.7526 8.65687C14.751 8.6512 14.7484 8.64585 14.7467 8.64027C14.7323 8.59293 14.7157 8.54824 14.695 8.50648C14.6876 8.49174 14.6796 8.47755 14.6715 8.46351C14.6658 8.45359 14.6601 8.44378 14.6539 8.43421C14.6409 8.41378 14.6278 8.39349 14.6129 8.37464L14.5573 8.31116C14.5437 8.29701 14.528 8.28506 14.5133 8.2721C14.5057 8.26543 14.4988 8.25793 14.4909 8.25159C14.4765 8.24005 14.4613 8.22981 14.4459 8.21937C14.4351 8.21202 14.4241 8.20467 14.4127 8.19788C14.4029 8.19197 14.3937 8.18481 14.3834 8.17933L14.3815 8.18128C14.2462 8.10932 14.078 8.07288 13.8766 8.07288ZM11.3932 11.9342L11.9567 12.6774V11.2282L11.3932 11.9342ZM4.68813 9.87366L6.07777 10.9801L5.23598 9.8639L5.23109 9.85706C5.14571 9.74191 5.06794 9.61462 5.00355 9.47718L4.68813 9.87366ZM11.1041 2.93714C10.7535 2.6581 10.4046 2.69556 10.1403 3.02698L10.11 3.06409L12.3873 4.87757C12.5422 5.00117 12.5742 5.20214 12.4489 5.35999C12.3275 5.51249 12.1145 5.54437 11.9645 5.42542L9.67934 3.60511L9.33559 4.03675L10.7955 5.19984C10.9533 5.32558 10.9815 5.52726 10.8561 5.68519C10.7389 5.83237 10.5261 5.86811 10.3707 5.74476L8.90492 4.57777L8.55922 5.01234L10.0192 6.17445C10.1769 6.30011 10.209 6.49628 10.0817 6.65687C9.96231 6.8068 9.75166 6.84078 9.59633 6.71741L8.13051 5.55042L7.78676 5.98109L9.2477 7.14417C9.40536 7.2699 9.43459 7.4687 9.30922 7.62659C9.18983 7.77655 8.97727 7.81271 8.82191 7.68909L7.35609 6.5221L7.01332 6.95374L7.11879 7.03773C7.33059 7.08343 7.53747 7.16459 7.73109 7.28773C8.02273 7.47334 8.25646 7.73167 8.44594 7.99769L8.82777 8.52796L9.21449 7.99476H9.21547C9.39786 7.73326 9.62935 7.47132 9.92738 7.28773C10.2519 7.08135 10.6131 6.99191 10.9743 6.99183C11.3887 6.99189 11.8172 7.10327 12.1803 7.39417H12.1813C12.185 7.3971 12.1884 7.40098 12.192 7.40394C12.1949 7.40628 12.1989 7.40841 12.2018 7.41077H12.2008C12.292 7.4843 12.3738 7.56566 12.4459 7.65296C12.4606 7.63712 12.4744 7.61962 12.4899 7.60413C12.6748 7.41932 12.8852 7.29256 13.1041 7.20863L13.9879 6.09925C14.2561 5.76197 14.2136 5.41361 13.8629 5.13441L11.1041 2.93714Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const RightArrowIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="17"
    height="10"
    viewBox="0 0 17 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.7521 9.68395L10.8572 8.79403L13.9645 5.69176H0.75V4.39915H13.9645L10.8572 1.2919L11.7521 0.40696L16.3906 5.04545L11.7521 9.68395Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const LeftArrowIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="17"
    height="10"
    viewBox="0 0 17 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.2479 9.68395L6.14284 8.79403L3.03554 5.69176H16.25V4.39915H3.03554L6.14284 1.2919L5.2479 0.40696L0.60943 5.04545L5.2479 9.68395Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const HandIcon = ({
  color = '152437',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.8072 12.1452C13.8072 15.799 11.2459 18 7.90878 18C5.64046 18 4.08077 17.1371 2.93674 15.3992C1.9431 14.0691 1.29784 11.9749 0.925714 10.7755C0.644632 9.89663 0.272506 8.77636 0.205215 8.2934C0.126087 7.7471 0.43084 7.31561 0.95344 7.23643C1.54722 7.14539 1.96686 7.47395 2.27559 8.13109L3.39983 10.6092C3.49088 10.819 3.582 10.8863 3.68488 10.8863C3.80763 10.8863 3.89867 10.815 3.89867 10.5894L3.89867 2.10997C3.89867 1.52805 4.33015 1.09259 4.91209 1.09259C5.48212 1.09259 5.92154 1.532 5.92154 2.10997L5.92154 8.4438C6.1076 8.3765 6.30553 8.32113 6.51534 8.2776L6.51534 1.01737C6.51534 0.439411 6.95079 0 7.52875 0C8.10672 0 8.54217 0.439411 8.54217 1.01737V8.19441C8.74406 8.2103 8.95387 8.23795 9.15576 8.26568V1.65868C9.15576 1.08467 9.59518 0.645262 10.1692 0.645262C10.7432 0.645262 11.1826 1.08467 11.1826 1.65868V8.81592C11.3964 8.91094 11.5943 9.0139 11.7764 9.12473V4.1368C11.7764 3.55488 12.2118 3.11943 12.7859 3.11943C13.3638 3.11943 13.8072 3.55488 13.8072 4.1368L13.8072 12.1452Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const TextIcon = ({
  color = '152437',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.07251 15.4648V13.8857L5.70288 13.5781V2.51416H2.69849L2.4729 4.42139H0.534912V0.535156H13.4651V4.42139H11.5168L11.2913 2.51416H8.28687V13.5781L9.91724 13.8857V15.4648H4.07251Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const PlusIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="0.5"
      width="15"
      height="15"
      rx="7.5"
      stroke={isFill ? activeColor : color}
    />
    <path
      d="M7.46593 12V8.80755H4.5V7.01887H7.46593V4H9.55812V7.01887H12.5V8.80755H9.55812V12H7.46593Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const MoreIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="16"
    height="4"
    viewBox="0 0 16 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9036 3.79148C14.8976 3.79148 15.7032 2.98587 15.7032 1.99588C15.7032 1.0019 14.8976 0.196289 13.9036 0.196289C12.9136 0.196289 12.104 1.0019 12.104 1.99588C12.104 2.98587 12.9136 3.79148 13.9036 3.79148Z"
      fill={isFill ? activeColor : color}
    />
    <path
      d="M7.85184 3.79148C8.84586 3.79148 9.64741 2.98587 9.64741 1.99588C9.64741 1.0019 8.84586 0.196289 7.85184 0.196289C6.85785 0.196289 6.05225 1.0019 6.05225 1.99588C6.05225 2.98587 6.85785 3.79148 7.85184 3.79148Z"
      fill={isFill ? activeColor : color}
    />
    <path
      d="M1.7996 3.79148C2.78958 3.79148 3.59519 2.98587 3.59519 1.99588C3.59519 1.0019 2.78958 0.196289 1.7996 0.196289C0.80561 0.196289 0 1.0019 0 1.99588C0 2.98587 0.80561 3.79148 1.7996 3.79148Z"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const AlignLeftIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="2"
      width="14"
      height="2"
      rx="1"
      fill={isFill ? activeColor : color}
    />
    <rect
      x="1"
      y="7"
      width="10"
      height="2"
      rx="1"
      fill={isFill ? activeColor : color}
    />
    <rect
      x="1"
      y="12"
      width="12"
      height="2"
      rx="1"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const AlignCenterIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="2"
      width="14"
      height="2"
      rx="1"
      fill={isFill ? activeColor : color}
    />
    <rect
      x="3"
      y="7"
      width="10"
      height="2"
      rx="1"
      fill={isFill ? activeColor : color}
    />
    <rect
      x="2"
      y="12"
      width="12"
      height="2"
      rx="1"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const AlignRightIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="2"
      width="14"
      height="2"
      rx="1"
      fill={isFill ? activeColor : color}
    />
    <rect
      x="5"
      y="7"
      width="10"
      height="2"
      rx="1"
      fill={isFill ? activeColor : color}
    />
    <rect
      x="3"
      y="12"
      width="12"
      height="2"
      rx="1"
      fill={isFill ? activeColor : color}
    />
  </svg>
);

export const LayersIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 20"
    width="16"
    height="16"
  >
    <g>
      <rect height="16" opacity="0" width="16" x="0" y="0" />
      <path
        d="M16.9717 13.1221C17.6836 13.5352 17.9648 13.8604 17.9648 14.335C17.9648 14.8184 17.6836 15.1436 16.9717 15.5566L10.0986 19.5469C9.67676 19.793 9.33398 19.9072 8.98242 19.9072C8.62207 19.9072 8.28809 19.793 7.86621 19.5469L0.984375 15.5566C0.272461 15.1436 0 14.8184 0 14.335C0 13.8604 0.272461 13.5352 0.984375 13.1221L2.3774 12.3144L3.82197 13.1538L1.89844 14.2559C1.86328 14.2734 1.83691 14.2998 1.83691 14.335C1.83691 14.3789 1.86328 14.4053 1.89844 14.4229L8.58691 18.2549C8.73633 18.334 8.85938 18.3779 8.98242 18.3779C9.10547 18.3779 9.22852 18.334 9.36914 18.2549L16.0576 14.4229C16.1016 14.4053 16.1279 14.3789 16.1279 14.335C16.1279 14.2998 16.1016 14.2734 16.0576 14.2559L14.1359 13.1549L15.5804 12.3144ZM5.28491 12.3156L5.28491 12.3156L3.86654 11.5049ZM12.6711 12.3156L12.6711 12.3156L13.4845 11.8507Z"
        fill={isFill ? activeColor : color}
      />
      <path
        d="M16.9717 9.07031C17.6836 9.49219 17.9648 9.80859 17.9648 10.292C17.9648 10.7754 17.6836 11.0918 16.9717 11.5049L10.0986 15.5039C9.67676 15.75 9.33398 15.8643 8.98242 15.8643C8.62207 15.8643 8.28809 15.75 7.86621 15.5039L0.984375 11.5049C0.272461 11.0918 0 10.7754 0 10.292C0 9.80859 0.272461 9.49219 0.984375 9.07031L2.61388 8.12549L4.06394 8.96626L1.89844 10.2041C1.86328 10.2217 1.83691 10.248 1.83691 10.292C1.83691 10.3359 1.86328 10.3535 1.89844 10.3799L8.58691 14.2031C8.73633 14.2822 8.85938 14.3262 8.98242 14.3262C9.10547 14.3262 9.22852 14.2822 9.36914 14.2031L16.0576 10.3799C16.1016 10.3535 16.1279 10.3359 16.1279 10.292C16.1279 10.248 16.1016 10.2217 16.0576 10.2041L13.8941 8.9674L15.3443 8.12549ZM5.53064 8.12787L4.57217 7.57874ZM12.4254 8.12787L12.4254 8.12787L13.8966 7.28501Z"
        fill={isFill ? activeColor : color}
      />
      <path
        d="M8.98242 11.5312C9.33398 11.5312 9.67676 11.417 10.0986 11.1709L16.9717 7.18066C17.6836 6.76758 17.9648 6.44238 17.9648 5.95898C17.9648 5.48438 17.6836 5.15918 16.9717 4.74609L10.0986 0.755859C9.67676 0.509766 9.33398 0.395508 8.98242 0.395508C8.62207 0.395508 8.28809 0.509766 7.86621 0.755859L0.984375 4.74609C0.272461 5.15918 0 5.48438 0 5.95898C0 6.44238 0.272461 6.76758 0.984375 7.18066L7.86621 11.1709C8.28809 11.417 8.62207 11.5312 8.98242 11.5312ZM8.98242 10.002C8.85938 10.002 8.73633 9.95801 8.58691 9.87891L1.89844 6.04688C1.86328 6.0293 1.83691 6.00293 1.83691 5.95898C1.83691 5.92383 1.86328 5.89746 1.89844 5.87988L8.58691 2.04785C8.73633 1.96875 8.85938 1.9248 8.98242 1.9248C9.10547 1.9248 9.22852 1.96875 9.36914 2.04785L16.0576 5.87988C16.1016 5.89746 16.1279 5.92383 16.1279 5.95898C16.1279 6.00293 16.1016 6.0293 16.0576 6.04688L9.36914 9.87891C9.22852 9.95801 9.10547 10.002 8.98242 10.002Z"
        fill={isFill ? activeColor : color}
      />
    </g>
  </svg>
);

// Placeholder "tune" icon (horizontal sliders); swap for a final asset later.
export const KebabDotsIcon = ({
  color = 'var(--text)',
}: {
  color?: string;
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill={color}
    >
      <path d="M480-160q-33 0-56.5-23.5T400-240q0-33 23.5-56.5T480-320q33 0 56.5 23.5T560-240q0 33-23.5 56.5T480-160Zm0-240q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm0-240q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Z" />
    </svg>
  </svg>
);

export const MoveTopIcon = () => (
  <svg
    width="9"
    height="13"
    viewBox="0 0 9 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_783_108)">
      <path
        d="M8.77571 5.9588C8.77571 5.81988 8.72942 5.69831 8.6194 5.58254L4.7757 1.73304C4.66571 1.61726 4.53257 1.55938 4.38785 1.55938C4.24313 1.55938 4.10999 1.61726 4.00001 1.73304L0.162085 5.58254C0.0520985 5.69831 0 5.81988 0 5.9588C0 6.24245 0.208394 6.46243 0.49783 6.46243C0.63676 6.46243 0.775687 6.41611 0.862521 6.32349L2.18235 5.02682L4.2605 2.75185L3.93054 2.63608L3.87265 4.36112V11.9907C3.87265 12.2917 4.08684 12.5 4.38785 12.5C4.68887 12.5 4.90305 12.2917 4.90305 11.9907V4.36112L4.84516 2.63608L4.52099 2.75185L6.59333 5.02682L7.91318 6.32349C8.00583 6.41611 8.13896 6.46243 8.27785 6.46243C8.5673 6.46243 8.77571 6.24245 8.77571 5.9588ZM8.77571 1.04418C8.77571 0.743165 8.5731 0.523193 8.27785 0.523193H0.509408C0.208394 0.523193 0 0.743165 0 1.04418C0 1.34519 0.208394 1.55938 0.509408 1.55938H8.27785C8.5731 1.55938 8.77571 1.34519 8.77571 1.04418Z"
        fill="var(--text)"
      />
    </g>
    <defs>
      <clipPath id="clip0_783_108">
        <rect
          width="8.98988"
          height="12"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const MoveUpIcon = () => (
  <svg
    width="10"
    height="13"
    viewBox="0 0 10 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_783_98)">
      <path
        d="M4.81524 12.5C5.14557 12.5 5.38061 12.2713 5.38061 11.941V3.57464L5.31709 1.68158L4.955 1.80863L7.23553 4.30518L8.68394 5.72815C8.78561 5.82979 8.93171 5.88061 9.08413 5.88061C9.40177 5.88061 9.63048 5.63922 9.63048 5.32795C9.63048 5.17548 9.57968 5.04208 9.45895 4.91503L5.24086 0.690577C5.12016 0.563526 4.97405 0.5 4.81524 0.5C4.65642 0.5 4.51031 0.563526 4.38962 0.690577L0.177872 4.91503C0.057173 5.04208 0 5.17548 0 5.32795C0 5.63922 0.228692 5.88061 0.54632 5.88061C0.698782 5.88061 0.85124 5.82979 0.946532 5.72815L2.39491 4.30518L4.66913 1.80863L4.31339 1.68158L4.24986 3.57464V11.941C4.24986 12.2713 4.4849 12.5 4.81524 12.5Z"
        fill="var(--text)"
      />
    </g>
    <defs>
      <clipPath id="clip0_783_98">
        <rect
          width="9.86551"
          height="12"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const MoveDownIcon = () => (
  <svg
    width="10"
    height="13"
    viewBox="0 0 10 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_783_103)">
      <path
        d="M4.81524 0.499999C5.14557 0.499999 5.38061 0.728716 5.38061 1.05904V9.42536L5.31709 11.3184L4.955 11.1914L7.23553 8.69482L8.68394 7.27185C8.78561 7.17021 8.93171 7.11939 9.08413 7.11939C9.40177 7.11939 9.63048 7.36078 9.63048 7.67205C9.63048 7.82452 9.57968 7.95792 9.45895 8.08497L5.24086 12.3094C5.12016 12.4365 4.97405 12.5 4.81524 12.5C4.65642 12.5 4.51031 12.4365 4.38962 12.3094L0.177872 8.08497C0.057173 7.95792 0 7.82452 0 7.67205C0 7.36078 0.228692 7.11939 0.54632 7.11939C0.698782 7.11939 0.85124 7.17021 0.946532 7.27185L2.39491 8.69482L4.66913 11.1914L4.31339 11.3184L4.24986 9.42536V1.05904C4.24986 0.728716 4.4849 0.499999 4.81524 0.499999Z"
        fill="var(--text)"
      />
    </g>
    <defs>
      <clipPath id="clip0_783_103">
        <rect
          width="9.86551"
          height="12"
          fill="white"
          transform="matrix(1 0 0 -1 0 12.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const MoveBottomIcon = () => (
  <svg
    width="9"
    height="13"
    viewBox="0 0 9 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_783_113)">
      <path
        d="M8.77571 7.0412C8.77571 7.18012 8.72942 7.30169 8.6194 7.41746L4.7757 11.267C4.66571 11.3827 4.53257 11.4406 4.38785 11.4406C4.24313 11.4406 4.10999 11.3827 4.00001 11.267L0.162085 7.41746C0.0520985 7.30169 0 7.18012 0 7.0412C0 6.75755 0.208394 6.53757 0.49783 6.53757C0.63676 6.53757 0.775687 6.58389 0.862521 6.67651L2.18235 7.97318L4.2605 10.2481L3.93054 10.3639L3.87265 8.63888V1.00933C3.87265 0.708319 4.08684 0.499962 4.38785 0.499962C4.68887 0.499962 4.90305 0.708319 4.90305 1.00933V8.63888L4.84516 10.3639L4.52099 10.2481L6.59333 7.97318L7.91318 6.67651C8.00583 6.58389 8.13896 6.53757 8.27785 6.53757C8.5673 6.53757 8.77571 6.75755 8.77571 7.0412ZM8.77571 11.9558C8.77571 12.2568 8.5731 12.4768 8.27785 12.4768H0.509408C0.208394 12.4768 0 12.2568 0 11.9558C0 11.6548 0.208394 11.4406 0.509408 11.4406H8.27785C8.5731 11.4406 8.77571 11.6548 8.77571 11.9558Z"
        fill="var(--text)"
      />
    </g>
    <defs>
      <clipPath id="clip0_783_113">
        <rect
          width="8.98988"
          height="12"
          fill="white"
          transform="matrix(1 0 0 -1 0 12.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const CopyIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="5.5"
      y="5.5"
      width="8"
      height="8"
      rx="1.5"
      stroke="var(--text)"
      strokeWidth="1.2"
    />
    <path
      d="M10.5 5.5V3.5C10.5 2.67157 9.82843 2 9 2H3.5C2.67157 2 2 2.67157 2 3.5V9C2 9.82843 2.67157 10.5 3.5 10.5H5.5"
      stroke="var(--text)"
      strokeWidth="1.2"
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="-1.3 -0.2 12.5 12.5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.35302 10.0052C3.54262 10.0052 3.66736 9.88544 3.66237 9.7108L3.50769 4.37194C3.50271 4.1973 3.37797 4.08254 3.19834 4.08254C3.00873 4.08254 2.88399 4.20229 2.88899 4.37693L3.03868 9.7108C3.04366 9.89044 3.1684 10.0052 3.35302 10.0052ZM4.82994 10.0052C5.01955 10.0052 5.15427 9.88544 5.15427 9.7108V4.37693C5.15427 4.20229 5.01955 4.08254 4.82994 4.08254C4.64034 4.08254 4.51061 4.20229 4.51061 4.37693V9.7108C4.51061 9.88544 4.64034 10.0052 4.82994 10.0052ZM6.31185 10.0052C6.4915 10.0052 6.61621 9.89044 6.62122 9.7108L6.77093 4.37693C6.77588 4.20229 6.65116 4.08254 6.46155 4.08254C6.28191 4.08254 6.15719 4.1973 6.15218 4.37693L6.00248 9.7108C5.99752 9.88544 6.12224 10.0052 6.31185 10.0052ZM2.63951 2.78025H3.43285V1.71248C3.43285 1.42807 3.63244 1.24345 3.93181 1.24345H5.71809C6.01745 1.24345 6.21707 1.42807 6.21707 1.71248V2.78025H7.0104V1.66258C7.0104 0.939086 6.54136 0.5 5.77297 0.5H3.87693C3.10853 0.5 2.63951 0.939086 2.63951 1.66258V2.78025ZM0.374221 3.17942H9.29066C9.49524 3.17942 9.65986 3.00478 9.65986 2.80021C9.65986 2.59564 9.49524 2.42599 9.29066 2.42599H0.374221C0.174636 2.42599 0 2.59564 0 2.80021C0 3.00977 0.174636 3.17942 0.374221 3.17942ZM2.5447 11.6118H7.12015C7.83367 11.6118 8.31268 11.1478 8.34762 10.4343L8.6969 3.08462H7.89355L7.55925 10.3495C7.54929 10.6489 7.33474 10.8584 7.04034 10.8584H2.61456C2.33015 10.8584 2.11559 10.6439 2.10063 10.3495L1.74636 3.08462H0.962997L1.31725 10.4393C1.35218 11.1528 1.82121 11.6118 2.5447 11.6118Z"
      fill="var(--text)"
    />
  </svg>
);

export const WellIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8.5" r="7.5" stroke={isFill ? activeColor : color} />
  </svg>
);

export const GenerelWellIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8.5" r="7.5" stroke={isFill ? activeColor : color} />
    <path d="M14 3L2 14" stroke={isFill ? activeColor : color} />
    <path
      d="M13.6654 14.1533L2.35168 2.8396"
      stroke={isFill ? activeColor : color}
    />
  </svg>
);

export const ThreeChamberWellIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8.5" r="7.5" stroke={isFill ? activeColor : color} />
    <path
      d="M2.3446 14.1533L8.00146 8.49646"
      stroke={isFill ? activeColor : color}
    />
    <path
      d="M13.6654 14.1533L2.35168 2.8396"
      stroke={isFill ? activeColor : color}
    />
  </svg>
);

export const DrillHoleIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="8"
      cy="8.5"
      r="7.5"
      fill={isFill ? activeColor : color}
      stroke={isFill ? activeColor : color}
    />
  </svg>
);

export const FixtureToolbarIcon = ({
  color = 'var(--text)',
  isFill,
  component: IconComponent,
  viewBoxWidth,
  viewBoxHeight,
  toolbarId,
}: SvgIconProp & {
  component: React.FC<FixtureIconProps>;
  viewBoxWidth: number;
  viewBoxHeight: number;
  toolbarId: string;
}) => (
  <svg
    viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
    fill="none"
    className="fixture-toolbar-icon"
  >
    <style>{'.fixture-toolbar-icon * { stroke-width: 6 !important; }'}</style>
    <IconComponent
      id={toolbarId}
      x={0}
      y={0}
      width={viewBoxWidth}
      height={viewBoxHeight}
      foregroundColor={isFill ? '#fff' : color}
      backgroundColor="var(--surface-elevated)"
    />
  </svg>
);

export const MirrorHorizontalIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill={isFill ? activeColor : color}
  >
    <path d="M360-120H200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h160v80H200v560h160v80Zm80 80v-880h80v880h-80Zm160-80v-80h80v80h-80Zm0-640v-80h80v80h-80Zm160 640v-80h80q0 33-23.5 56.5T760-120Zm0-160v-80h80v80h-80Zm0-160v-80h80v80h-80Zm0-160v-80h80v80h-80Zm0-160v-80q33 0 56.5 23.5T840-760h-80Z" />
  </svg>
);

export const MirrorVerticalIcon = ({
  color = 'var(--text)',
  isFill,
  activeColor = '#fff',
}: SvgIconProp) => (
  <svg
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill={isFill ? activeColor : color}
  >
    <path
      transform="rotate(90 480 -480)"
      d="M360-120H200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h160v80H200v560h160v80Zm80 80v-880h80v880h-80Zm160-80v-80h80v80h-80Zm0-640v-80h80v80h-80Zm160 640v-80h80q0 33-23.5 56.5T760-120Zm0-160v-80h80v80h-80Zm0-160v-80h80v80h-80Zm0-160v-80h80v80h-80Zm0-160v-80q33 0 56.5 23.5T840-760h-80Z"
    />
  </svg>
);

export const GroupIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* group bounding box */}
    <rect x="3" y="3" width="18" height="18" rx="1" strokeDasharray="3 2.5" />
    {/* two stacked elements */}
    <rect x="6.5" y="6.5" width="7" height="7" rx="0.75" />
    <rect x="10.5" y="10.5" width="7" height="7" rx="0.75" />
    {/* corner handles */}
    <rect
      x="1.5"
      y="1.5"
      width="3"
      height="3"
      fill="currentColor"
      stroke="none"
    />
    <rect
      x="19.5"
      y="1.5"
      width="3"
      height="3"
      fill="currentColor"
      stroke="none"
    />
    <rect
      x="1.5"
      y="19.5"
      width="3"
      height="3"
      fill="currentColor"
      stroke="none"
    />
    <rect
      x="19.5"
      y="19.5"
      width="3"
      height="3"
      fill="currentColor"
      stroke="none"
    />
  </svg>
);

// The same two elements as GroupIcon, minus the dashed box and handles that
// mark them as one unit — what's left once the group is dissolved.
export const UngroupIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="4" y="4" width="8.5" height="8.5" rx="0.75" />
    <rect x="11.5" y="11.5" width="8.5" height="8.5" rx="0.75" />
  </svg>
);
